// tslint:disable
import { Injectable } from '@angular/core';

import { DwItem, DwItemDetail, DwQuery, DwOrmData } from '@devwareapps/devware-cap';
import * as EnterpriseMetaData from '@devwareapps/devware-cap';

/************************************************
   Generated with the Devware CAP CLI 4.4.22
   Code Gen Name   Permits
   API Url         https://wappsdev.wachter.com/DevwareCapApi/

   Generated By    MLT-MSI/mlt
   Generate On     3/27/2023 2:13:58 PM
************************************************/

export enum PermitsMetaDataItemNames {
    AccessControl = 'AccessControl',
    CodeValue = 'CodeValue',
    EthosCodeValue = 'Ethos_CodeValue',
    EthosCodeValueCustom = 'Ethos_CodeValueCustom',
    EthosJob = 'Ethos_Job',
    EthosJobNumber = 'Ethos_JobNumber',
    EthosJobNumberForecast = 'Ethos_JobNumberForecast',
    EthosJobNumberPhase = 'Ethos_JobNumberPhase',
    EthosJobSite = 'Ethos_JobSite',
    EthosJobSow = 'Ethos_JobSow',
    EthosOpportunity = 'Ethos_Opportunity',
    EthosUser = 'Ethos_User',
    EthosUserDiff = 'Ethos_UserDiff',
    EthosUserSkill = 'Ethos_UserSkill',
    EthosWachterDepartment = 'Ethos_WachterDepartment',
    EthosWachterTeam = 'Ethos_WachterTeam',
    EthosWorkflowStatus = 'Ethos_WorkflowStatus',
    EthosWorkflowStatusSet = 'Ethos_WorkflowStatusSet',
    Inspection = 'Inspection',
    NoteType = 'NoteType',
    Permit = 'Permit',
    PermitPermitType = 'PermitPermitType',
    PermitRequest = 'permitRequest',
    PermitRequestPermit = 'PermitRequestPermit',
    PermitRequestPermitType = 'PermitRequestPermitType',
    PermitStatus = 'PermitStatus',
    RequiredCable = 'RequiredCable',
    RoEthosUser = 'roEthos_User',
    RoEthosUserOriginal = 'roEthos_UserOriginal',
    RoInspections = 'roInspections',
    RoPermitRequestLastNote = 'roPermitRequestLastNote',
    RoPermitRequests = 'roPermitRequests',
    RoPermits = 'roPermits',
}

export enum PermitsMetaDataLookups {
    AccessControlAllItems = 2810,
    CodeValueAccessControl = 2811,
    CodeValueAccessControlAdditionalOptions = 1849,
    CodeValueCCTVTypesOfInstall = 1851,
    CodeValueDifferentTypeOfElectrical = 1846,
    CodeValueElectricalNewWorkType = 1848,
    CodeValueFireAlarmDemoOrInstall = 1850,
    CodeValueInspectionState = 1866,
    CodeValueInspectionTimeOfDay = 1863,
    CodeValueLicenseStatus = 1467,
    CodeValueMORSubTypeByIssueType = 1513,
    CodeValuePassFail = 1867,
    CodeValuePerformWork = 1803,
    CodeValuePermitRequestCableType = 1799,
    CodeValuePermitRequestElectricalOutletType = 1845,
    CodeValuePermitRequestStatus = 1801,
    CodeValuePermitRequestType = 1798,
    CodeValueTypesOfElectrical = 1847,
    CodeValueAccidentType = 1541,
    CodeValueAccidentTypeWorkplace = 1648,
    CodeValueAirportPlan = 1596,
    CodeValueAtFault = 1542,
    CodeValueBodyPart = 1684,
    CodeValueBodySide = 1685,
    CodeValueBusinessPlanReviewAccidentType = 1587,
    CodeValueClaimStatus = 1544,
    CodeValueEmployeeTrainingNeeded = 1525,
    CodeValueEmployeeTrainingNeededConclusion = 1532,
    CodeValueEmployeeTrainingNeededStatus = 1534,
    CodeValueEmsWorkStatus = 1638,
    CodeValueEquipmentDelivery = 1453,
    CodeValueFiveStarRatingValue = 1616,
    CodeValueInjuryType = 1683,
    CodeValueInspectionResults = 1869,
    CodeValueInsuranceCompany = 1545,
    CodeValueLodgingPlan = 1598,
    CodeValueMemoOfRecordIssueSubTypeAll = 1515,
    CodeValueMemoOfRecordConclusion = 1511,
    CodeValueMemoOfRecordEmployeeType = 1510,
    CodeValueMemoOfRecordIssueType = 1512,
    CodeValueMORStatus = 1517,
    CodeValuePayJobChangeDepartmentRole = 1485,
    CodeValuePayJobChangeStatus = 1481,
    CodeValuePayJobChangeType = 1486,
    CodeValuePermitTeam = 1731,
    CodeValuePermitType = 1726,
    CodeValuePlenumOrRiser = 1727,
    CodeValueTechType = 1586,
    CodeValueTermResignType = 1487,
    CodeValueTransportationPlan = 1597,
    CodeValueTravelMode = 1595,
    CodeValueTravelRequestStatus = 1601,
    CodeValueTravelType = 1599,
    CodeValueVechicleRepaired = 1543,
    CodeValueWorkerType = 1792,
    CodeValueWorksiteType = 1647,
    EthosInvoiceDeliveryType = 1707,
    EthosUserTypeCodeValue = 1690,
    EthosCodeValueAllItems = 1631,
    EthosCodeValueCustomAllItems = 1733,
    EthosJobAllItems = 1716,
    EthosJobNumberActiveOnlyForKickoff = 1750,
    EthosJobNumberAllItems = 1378,
    EthosJobNumberEndDate = 1504,
    EthosJobNumberForecastAllItems = 1377,
    EthosJobNumberPhaseAllItems = 1588,
    EthosJobSiteAllItems = 1717,
    EthosJobSowAllItems = 1718,
    EthosOpportunityAllItems = 1793,
    EthosUserBySupervisor = 1758,
    EthosUserBySupervisorPlusIndirect = 1773,
    EthosUserByUsersDepartment = 1582,
    ETHOSUSERNSPLBUOfficeActiveEmployees = 1696,
    ETHOSUSERWachterEmployeesActiveEmployees = 1464,
    EthosUserAllItems = 1416,
    EthosUserDiffAllItems = 1623,
    EthosUserSkillAllItems = 1413,
    EthosWachterDepartmentAllItems = 1391,
    EthosWachterTeamNSPLBU = 1709,
    EthosWachterTeamAllItems = 1415,
    EthosWachterTeamAllItemsWithDivision = 1860,
    EthosWorkflowStatusUserStatus = 1640,
    EthosWorkflowStatusAllItems = 1633,
    EthosWorkflowStatusSetAllItems = 1632,
    InspectionAllItems = 1862,
    JobByOpportunityId = 1794,
    JobLookupWithJobNumber = 1729,
    JobSiteSiteInfo = 1788,
    JobNumberActive = 1872,
    JobSowScopeOfWorkAndSiteInfo = 1725,
    NoteTypeAllItems = 1839,
    OverheadJobNumbers = 1589,
    PermitAllItems = 1714,
    PermitRequestJobTypeLookup = 1811,
    PermitRequestJobTypeLookupNoJobNumber = 1873,
    PermitPermitTypeAllItems = 1776,
    PermitRequestAllItems = 1671,
    PermitRequestPermitAllItems = 1806,
    PermitRequestPermitTypeAllItems = 1864,
    PermitStatusAllItems = 1859,
    PlenumRiseOutdoor = 1796,
    RequiredCableAllItems = 1870,
    RoEthosUserAllItems = 1422,
    RoEthosUserOriginalAllItems = 1753,
    RoInspectionsAllItems = 1868,
    RoPermitRequestLastNoteAllItems = 1861,
    RoPermitRequestsAllItems = 1808,
    RoPermitsAllItems = 1807,
    TrustCodeValueAllItems = 1388,
    WachterDivisions = 1858,
    WachterTeamByDepartment = 1768,
    WachterTeamDepartment = 1496,
    WJIDByJobNumber = 1871,
    WorkflowStatusJobNumberStatus = 1751,
    WorkflowStatusPermitStatusDONOTUSE = 1728,
}

@Injectable({
    providedIn: 'root'
})
export class PermitsMetaDataService {

    AccessControl : AccessControl = new AccessControl();
    CodeValue : CodeValue = new CodeValue();
    EthosCodeValue : EthosCodeValue = new EthosCodeValue();
    EthosCodeValueCustom : EthosCodeValueCustom = new EthosCodeValueCustom();
    EthosJob : EthosJob = new EthosJob();
    EthosJobNumber : EthosJobNumber = new EthosJobNumber();
    EthosJobNumberForecast : EthosJobNumberForecast = new EthosJobNumberForecast();
    EthosJobNumberPhase : EthosJobNumberPhase = new EthosJobNumberPhase();
    EthosJobSite : EthosJobSite = new EthosJobSite();
    EthosJobSow : EthosJobSow = new EthosJobSow();
    EthosOpportunity : EthosOpportunity = new EthosOpportunity();
    EthosUser : EthosUser = new EthosUser();
    EthosUserDiff : EthosUserDiff = new EthosUserDiff();
    EthosUserSkill : EthosUserSkill = new EthosUserSkill();
    EthosWachterDepartment : EthosWachterDepartment = new EthosWachterDepartment();
    EthosWachterTeam : EthosWachterTeam = new EthosWachterTeam();
    EthosWorkflowStatus : EthosWorkflowStatus = new EthosWorkflowStatus();
    EthosWorkflowStatusSet : EthosWorkflowStatusSet = new EthosWorkflowStatusSet();
    Inspection : Inspection = new Inspection();
    NoteType : NoteType = new NoteType();
    Permit : Permit = new Permit();
    PermitPermitType : PermitPermitType = new PermitPermitType();
    PermitRequest : PermitRequest = new PermitRequest();
    PermitRequestPermit : PermitRequestPermit = new PermitRequestPermit();
    PermitRequestPermitType : PermitRequestPermitType = new PermitRequestPermitType();
    PermitStatus : PermitStatus = new PermitStatus();
    RequiredCable : RequiredCable = new RequiredCable();
    RoEthosUser : RoEthosUser = new RoEthosUser();
    RoEthosUserOriginal : RoEthosUserOriginal = new RoEthosUserOriginal();
    RoInspections : RoInspections = new RoInspections();
    RoPermitRequestLastNote : RoPermitRequestLastNote = new RoPermitRequestLastNote();
    RoPermitRequests : RoPermitRequests = new RoPermitRequests();
    RoPermits : RoPermits = new RoPermits();
}

// Generated Classes for MetaData service
class AccessControl implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'AccessControl.';

    constructor() {
        this.ItemDetail.ItemId=2751;
        this.ItemDetail.ItemName='AccessControl';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    AccessControlId : string = this.i + 'AccessControlId';
    AccessControlCv : string = this.i + 'AccessControlCv';
    Quantity : string = this.i + 'Quantity';
    Description : string = this.i + 'Description';
    PermitRequestId : string = this.i + 'PermitRequestId';
    PermitId : string = this.i + 'PermitId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';

    Relations = {
            /** Relation: Permit */
            Permit : {
                RelationName: 'Permit|AccessControl|PermitId',
                FieldPrefix: 'Permit',
                PropertyName: 'Permit'
            },
            /** Relation: Trust Code Value - Access Control Cv */
            CodeValueByAccessControlCv : {
                RelationName: 'CodeValue|AccessControl|AccessControlCv',
                FieldPrefix: 'AccessControlCvCodeValue',
                PropertyName: 'AccessControlCvCodeValue'
            },
            /** Relation: Ethos User - Created By Ethos User */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|AccessControl|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|AccessControl|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Permit Request */
            PermitRequest : {
                RelationName: 'permitRequest|AccessControl|PermitRequestId',
                FieldPrefix: 'PermitRequest',
                PropertyName: 'PermitRequest'
            },
    };
}

class CodeValue implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'CodeValue.';

    constructor() {
        this.ItemDetail.ItemId=2385;
        this.ItemDetail.ItemName='CodeValue';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CodeValueId : string = this.i + 'CodeValueId';
    CodeSetId : string = this.i + 'CodeSetId';
    Display : string = this.i + 'Display';
    Meaning : string = this.i + 'Meaning';
    Description : string = this.i + 'Description';
    CodeValueOrder : string = this.i + 'CodeValueOrder';
    IsActive : string = this.i + 'IsActive';

    Relations = {
            /** Relation: Permit - Fire Alarm Demo Install Cv - Many */
            PermitByFireAlarmDemoInstallCv : {
                RelationName: 'CodeValue|Permit|FireAlarmDemoInstallCv',
                FieldPrefix: 'FireAlarmDemoInstallCvPermit',
                PropertyName: 'FireAlarmDemoInstallCvPermit'
            },
            /** Relation: Permit Request - C C T V Cable Type C V - Many */
            PermitRequestByCCTVCableTypeCV : {
                RelationName: 'CodeValue|permitRequest|CCTVCableTypeCV',
                FieldPrefix: 'CCTVCableTypeCVPermitRequest',
                PropertyName: 'CCTVCableTypeCVPermitRequest'
            },
            /** Relation: Permit - Cable Type Cv - Many */
            PermitByCableTypeCv : {
                RelationName: 'CodeValue|Permit|CableTypeCv',
                FieldPrefix: 'CableTypeCvPermit',
                PropertyName: 'CableTypeCvPermit'
            },
            /** Relation: Permit Request - C C T V Install Type Cv - Many */
            PermitRequestByCCTVInstallTypeCv : {
                RelationName: 'CodeValue|permitRequest|CCTVInstallTypeCv',
                FieldPrefix: 'CCTVInstallTypeCvPermitRequest',
                PropertyName: 'CCTVInstallTypeCvPermitRequest'
            },
            /** Relation: Permit Request - Electrical Outlet Type Cv - Many */
            PermitRequestByElectricalOutletTypeCv : {
                RelationName: 'CodeValue|permitRequest|ElectricalOutletTypeCv',
                FieldPrefix: 'ElectricalOutletTypeCvPermitRequest',
                PropertyName: 'ElectricalOutletTypeCvPermitRequest'
            },
            /** Relation: Permit Request - Fire Alarm Demo Install Cv - Many */
            PermitRequestByFireAlarmDemoInstallCv : {
                RelationName: 'CodeValue|permitRequest|FireAlarmDemoInstallCv',
                FieldPrefix: 'FireAlarmDemoInstallCvPermitRequest',
                PropertyName: 'FireAlarmDemoInstallCvPermitRequest'
            },
            /** Relation: Inspection - Result Cv - Many */
            InspectionByResultCv : {
                RelationName: 'CodeValue|Inspection|ResultCv',
                FieldPrefix: 'ResultCvInspection',
                PropertyName: 'ResultCvInspection'
            },
            /** Relation: Permit Request - Electrical Different Type Cv - Many */
            PermitRequestByElectricalDifferentTypeCv : {
                RelationName: 'CodeValue|permitRequest|ElectricalDifferentTypeCv',
                FieldPrefix: 'ElectricalDifferentTypeCvPermitRequest',
                PropertyName: 'ElectricalDifferentTypeCvPermitRequest'
            },
            /** Relation: Permit Request - Voice Data Cable Type C V - Many */
            PermitRequestByVoiceDataCableTypeCV : {
                RelationName: 'CodeValue|permitRequest|VoiceDataCableTypeCV',
                FieldPrefix: 'VoiceDataCableTypeCVPermitRequest',
                PropertyName: 'VoiceDataCableTypeCVPermitRequest'
            },
            /** Relation: Access Control - Access Control Cv - Many */
            AccessControlByAccessControlCv : {
                RelationName: 'CodeValue|AccessControl|AccessControlCv',
                FieldPrefix: 'AccessControlCvAccessControl',
                PropertyName: 'AccessControlCvAccessControl'
            },
            /** Relation: Permit Request - Status Cv - Many */
            PermitRequestByStatusCv : {
                RelationName: 'CodeValue|permitRequest|StatusCv',
                FieldPrefix: 'StatusCvPermitRequest',
                PropertyName: 'StatusCvPermitRequest'
            },
            /** Relation: Permit Request - Permit Request Type Cv - Many */
            PermitRequestByPermitRequestTypeCv : {
                RelationName: 'CodeValue|permitRequest|PermitRequestTypeCv',
                FieldPrefix: 'PermitRequestTypeCvPermitRequest',
                PropertyName: 'PermitRequestTypeCvPermitRequest'
            },
            /** Relation: Permit - C C T V Install Type Cv - Many */
            PermitByCCTVInstallTypeCv : {
                RelationName: 'CodeValue|Permit|CCTVInstallTypeCv',
                FieldPrefix: 'CCTVInstallTypeCvPermit',
                PropertyName: 'CCTVInstallTypeCvPermit'
            },
            /** Relation: Permit Permit Type - Permit Type Cv - Many */
            PermitPermitTypeByPermitTypeCv : {
                RelationName: 'CodeValue|PermitPermitTypeOld|PermitTypeCv',
                FieldPrefix: 'PermitTypeCvPermitPermitType',
                PropertyName: 'PermitTypeCvPermitPermitType'
            },
            /** Relation: Permit - Electrical Work Type Cv - Many */
            PermitByElectricalWorkTypeCv : {
                RelationName: 'CodeValue|Permit|ElectricalWorkTypeCv',
                FieldPrefix: 'ElectricalWorkTypeCvPermit',
                PropertyName: 'ElectricalWorkTypeCvPermit'
            },
            /** Relation: Permit Request - Audio Cable Type C V - Many */
            PermitRequestByAudioCableTypeCV : {
                RelationName: 'CodeValue|permitRequest|AudioCableTypeCV',
                FieldPrefix: 'AudioCableTypeCVPermitRequest',
                PropertyName: 'AudioCableTypeCVPermitRequest'
            },
            /** Relation: Permit - Access Control Type Cv - Many */
            PermitByAccessControlTypeCv : {
                RelationName: 'CodeValue|Permit|AccessControlTypeCv',
                FieldPrefix: 'AccessControlTypeCvPermit',
                PropertyName: 'AccessControlTypeCvPermit'
            },
            /** Relation: Inspection - Preferred Time Of Day Cv - Many */
            InspectionByPreferredTimeOfDayCv : {
                RelationName: 'CodeValue|Inspection|PreferredTimeOfDayCv',
                FieldPrefix: 'PreferredTimeOfDayCvInspection',
                PropertyName: 'PreferredTimeOfDayCvInspection'
            },
            /** Relation: Permit - Electrical Outlet Type Cv - Many */
            PermitByElectricalOutletTypeCv : {
                RelationName: 'CodeValue|Permit|ElectricalOutletTypeCv',
                FieldPrefix: 'ElectricalOutletTypeCvPermit',
                PropertyName: 'ElectricalOutletTypeCvPermit'
            },
            /** Relation: Permit - Inspection State Cv - Many */
            PermitByInspectionStateCv : {
                RelationName: 'CodeValue|Permit|InspectionStateCv',
                FieldPrefix: 'InspectionStateCvPermit',
                PropertyName: 'InspectionStateCvPermit'
            },
            /** Relation: Permit Request - Access Control C V - Many */
            PermitRequestByAccessControlCV : {
                RelationName: 'CodeValue|permitRequest|AccessControlCV',
                FieldPrefix: 'AccessControlCVPermitRequest',
                PropertyName: 'AccessControlCVPermitRequest'
            },
            /** Relation: Permit Request Permit Type - Permit Type Cv - Many */
            PermitRequestPermitTypeByPermitTypeCv : {
                RelationName: 'CodeValue|PermitRequestPermitType|PermitTypeCv',
                FieldPrefix: 'PermitTypeCvPermitRequestPermitType',
                PropertyName: 'PermitTypeCvPermitRequestPermitType'
            },
            /** Relation: Permit - Electrical Different Type Cv - Many */
            PermitByElectricalDifferentTypeCv : {
                RelationName: 'CodeValue|Permit|ElectricalDifferentTypeCv',
                FieldPrefix: 'ElectricalDifferentTypeCvPermit',
                PropertyName: 'ElectricalDifferentTypeCvPermit'
            },
            /** Relation: Permit Request - Electrical Work Type Cv - Many */
            PermitRequestByElectricalWorkTypeCv : {
                RelationName: 'CodeValue|permitRequest|ElectricalWorkTypeCv',
                FieldPrefix: 'ElectricalWorkTypeCvPermitRequest',
                PropertyName: 'ElectricalWorkTypeCvPermitRequest'
            },
            /** Relation: Permit Request - Access Control Other Type Cv - Many */
            PermitRequestByAccessControlOtherTypeCv : {
                RelationName: 'CodeValue|permitRequest|AccessControlOtherTypeCv',
                FieldPrefix: 'AccessControlOtherTypeCvPermitRequest',
                PropertyName: 'AccessControlOtherTypeCvPermitRequest'
            },
    };
}

class EthosCodeValue implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_CodeValue.';

    constructor() {
        this.ItemDetail.ItemId=2579;
        this.ItemDetail.ItemName='Ethos_CodeValue';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CodeValueId : string = this.i + 'CodeValueId';
    CodeSetId : string = this.i + 'CodeSetId';
    Display : string = this.i + 'Display';
    Meaning : string = this.i + 'Meaning';
    Description : string = this.i + 'Description';
    CodeValueOrder : string = this.i + 'CodeValueOrder';
    IsActive : string = this.i + 'IsActive';
    ImagePath : string = this.i + 'ImagePath';

    Relations = {
            /** Relation: Permit Request Permit - Permit Type C V - Many */
            PermitRequestPermitByPermitTypeCV : {
                RelationName: 'Ethos_CodeValue|PermitRequestPermit|PermitTypeCV',
                FieldPrefix: 'PermitTypeCVPermitRequestPermit',
                PropertyName: 'PermitTypeCVPermitRequestPermit'
            },
            /** Relation: Permit Request - Cable Type Cv - Many */
            PermitRequestByCableTypeCv : {
                RelationName: 'Ethos_CodeValue|permitRequest|CableTypeCv',
                FieldPrefix: 'CableTypeCvPermitRequest',
                PropertyName: 'CableTypeCvPermitRequest'
            },
            /** Relation: Permit Request - Permit Type Cv - Many */
            PermitRequestByPermitTypeCv : {
                RelationName: 'Ethos_CodeValue|permitRequest|PermitTypeCv',
                FieldPrefix: 'PermitTypeCvPermitRequest',
                PropertyName: 'PermitTypeCvPermitRequest'
            },
            /** Relation: Permit - Cable Type Cv - Many */
            PermitByCableTypeCv : {
                RelationName: 'Ethos_CodeValue|Permit|CableTypeCv',
                FieldPrefix: 'CableTypeCvPermit',
                PropertyName: 'CableTypeCvPermit'
            },
            /** Relation: Required Cable - Permit Type Cv - Many */
            RequiredCableByPermitTypeCv : {
                RelationName: 'Ethos_CodeValue|RequiredCable|PermitTypeCv',
                FieldPrefix: 'PermitTypeCvRequiredCable',
                PropertyName: 'PermitTypeCvRequiredCable'
            },
            /** Relation: Permit - Plenum Or Riser Cv - Many */
            PermitByPlenumOrRiserCv : {
                RelationName: 'Ethos_CodeValue|Permit|PlenumOrRiserCv',
                FieldPrefix: 'PlenumOrRiserCvPermit',
                PropertyName: 'PlenumOrRiserCvPermit'
            },
            /** Relation: Permit Request - Permit Team Cv - Many */
            PermitRequestByPermitTeamCv : {
                RelationName: 'Ethos_CodeValue|permitRequest|PermitTeamCv',
                FieldPrefix: 'PermitTeamCvPermitRequest',
                PropertyName: 'PermitTeamCvPermitRequest'
            },
            /** Relation: Ethos User - User Type Cv - Many */
            EthosUserByUserTypeCv : {
                RelationName: 'Ethos_CodeValue|Ethos_User|UserTypeCv',
                FieldPrefix: 'UserTypeCvEthosUser',
                PropertyName: 'UserTypeCvEthosUser'
            },
            /** Relation: Permit Request - Plenum Riser - Many */
            PermitRequestByPlenumRiser : {
                RelationName: 'Ethos_CodeValue|permitRequest|PlenumRiser',
                FieldPrefix: 'PlenumRiserPermitRequest',
                PropertyName: 'PlenumRiserPermitRequest'
            },
            /** Relation: Permit - Permit Type Cv - Many */
            PermitByPermitTypeCv : {
                RelationName: 'Ethos_CodeValue|Permit|PermitTypeCv',
                FieldPrefix: 'PermitTypeCvPermit',
                PropertyName: 'PermitTypeCvPermit'
            },
            /** Relation: Permit - Performing Work Cv - Many */
            PermitByPerformingWorkCv : {
                RelationName: 'Ethos_CodeValue|Permit|PerformingWorkCv',
                FieldPrefix: 'PerformingWorkCvPermit',
                PropertyName: 'PerformingWorkCvPermit'
            },
            /** Relation: Permit - Permit Team Cv - Many */
            PermitByPermitTeamCv : {
                RelationName: 'Ethos_CodeValue|Permit|PermitTeamCv',
                FieldPrefix: 'PermitTeamCvPermit',
                PropertyName: 'PermitTeamCvPermit'
            },
            /** Relation: Permit Permit Type - Permit Type Cv - Many */
            PermitPermitTypeByPermitTypeCv : {
                RelationName: 'Ethos_CodeValue|PermitPermitType|PermitTypeCv',
                FieldPrefix: 'PermitTypeCvPermitPermitType',
                PropertyName: 'PermitTypeCvPermitPermitType'
            },
            /** Relation: Permit Request Permit Type - Permit Type Cv - Many */
            PermitRequestPermitTypeByPermitTypeCv : {
                RelationName: 'Ethos_CodeValue|PermitRequestPermitType|PermitTypeCv',
                FieldPrefix: 'PermitTypeCvPermitRequestPermitType',
                PropertyName: 'PermitTypeCvPermitRequestPermitType'
            },
    };
}

class EthosCodeValueCustom implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_CodeValueCustom.';

    constructor() {
        this.ItemDetail.ItemId=2643;
        this.ItemDetail.ItemName='Ethos_CodeValueCustom';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CodeValueCustomId : string = this.i + 'CodeValueCustomId';
    CodeSetId : string = this.i + 'CodeSetId';
    Display : string = this.i + 'Display';
    Meaning : string = this.i + 'Meaning';
    Description : string = this.i + 'Description';
    CodeValueOrder : string = this.i + 'CodeValueOrder';
    IsActive : string = this.i + 'IsActive';

    Relations = {
    };
}

class EthosJob implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_Job.';

    constructor() {
        this.ItemDetail.ItemId=2635;
        this.ItemDetail.ItemName='Ethos_Job';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    JobId : string = this.i + 'JobId';
    JobNumberId : string = this.i + 'JobNumberId';
    JobEtcDateTime : string = this.i + 'JobEtcDateTime';

    Relations = {
            /** Relation: Permit Request */
            PermitRequest : {
                RelationName: 'Ethos_Job|permitRequest|JobId',
                FieldPrefix: 'PermitRequest',
                PropertyName: 'PermitRequest'
            },
            /** Relation: Permit */
            Permit : {
                RelationName: 'Ethos_Job|Permit|JobId',
                FieldPrefix: 'Permit',
                PropertyName: 'Permit'
            },
            /** Relation: Ethos Job Site */
            EthosJobSite : {
                RelationName: 'Ethos_Job|Ethos_JobSite|JobId',
                FieldPrefix: 'EthosJobSite',
                PropertyName: 'EthosJobSite'
            },
            /** Relation: Ethos Job Sow */
            EthosJobSow : {
                RelationName: 'Ethos_Job|Ethos_JobSow|JobId',
                FieldPrefix: 'EthosJobSow',
                PropertyName: 'EthosJobSow'
            },
            /** Relation: Ethos Job Site */
            EthosJobSiteByJobId : {
                RelationName: 'Job Site -> Job',
                FieldPrefix: 'EthosJobSiteJobId',
                PropertyName: 'EthosJobSiteJobId'
            },
            /** Relation: Job Number */
            EthosJobNumberByJobNumberId : {
                RelationName: 'JobToJobNumber',
                FieldPrefix: 'EthosJobNumberJobNumberId',
                PropertyName: 'EthosJobNumberJobNumberId'
            },
            /** Relation: Permit Request - Job - Many */
            PermitRequestByWJID : {
                RelationName: 'Job|PermitRequest|JobId',
                FieldPrefix: 'WJIDPermitRequest',
                PropertyName: 'WJIDPermitRequest'
            },
            /** Relation: Job Number */
            EthosJobNumber : {
                RelationName: 'Ethos_JobNumber|Ethos_Job|JobNumberId',
                FieldPrefix: 'EthosJobNumber',
                PropertyName: 'EthosJobNumber'
            },
    };
}

class EthosJobNumber implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_JobNumber.';

    constructor() {
        this.ItemDetail.ItemId=2375;
        this.ItemDetail.ItemName='Ethos_JobNumber';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    JobNumberId : string = this.i + 'JobNumberId';
    JobNumberStatusWs : string = this.i + 'JobNumberStatusWs';
    JobNumberStatus : string = this.i + 'JobNumberStatus';
    JobNumber : string = this.i + 'JobNumber';
    CustomerId : string = this.i + 'CustomerId';
    JobName : string = this.i + 'JobName';
    EstimatedStartDate : string = this.i + 'EstimatedStartDate';
    EstimatedEndDate : string = this.i + 'EstimatedEndDate';
    ProjectMgr1UserId : string = this.i + 'ProjectMgr1UserId';
    ProjectMgr2UserId : string = this.i + 'ProjectMgr2UserId';
    AsstProjectMgrUserId : string = this.i + 'AsstProjectMgrUserId';
    SeniorMgrUserId : string = this.i + 'SeniorMgrUserId';
    LeadTech1UserId : string = this.i + 'LeadTech1UserId';
    LeadTech2UserId : string = this.i + 'LeadTech2UserId';
    InvoiceApproval1UserId : string = this.i + 'InvoiceApproval1UserId';
    InvoiceApproval2UserId : string = this.i + 'InvoiceApproval2UserId';
    ForecastStatusCv : string = this.i + 'ForecastStatusCv';
    ForecastStatus : string = this.i + 'ForecastStatus';
    WachterTeamId : string = this.i + 'WachterTeamId';
    CustomerName : string = this.i + 'CustomerName';
    CustomerShortName : string = this.i + 'CustomerShortName';
    BillingInstructions : string = this.i + 'BillingInstructions';
    ChangeOrderProcessInstructions : string = this.i + 'ChangeOrderProcessInstructions';
    PartialBilling : string = this.i + 'PartialBilling';
    FinalInvoiceDate : string = this.i + 'FinalInvoiceDate';
    InvoiceDeliveryTypeData : string = this.i + 'InvoiceDeliveryTypeData';
    InvoiceDeliveryTypeCV : string = this.i + 'InvoiceDeliveryTypeCV';
    OpportunityId : string = this.i + 'OpportunityId';
    EndCustomerId : string = this.i + 'EndCustomerId';

    Relations = {
            /** Relation: Ethos User - Project Mgr1 User - Many */
            EthosUserByUserId : {
                RelationName: 'JobNumber->ProjectManager',
                FieldPrefix: 'UserIdEthosUser',
                PropertyName: 'UserIdEthosUser'
            },
            /** Relation: Ethos Job */
            EthosJob : {
                RelationName: 'Ethos_JobNumber|Ethos_Job|JobNumberId',
                FieldPrefix: 'EthosJob',
                PropertyName: 'EthosJob'
            },
            /** Relation: Ethos Opportunity */
            EthosOpportunity : {
                RelationName: 'OpportunityToJobNumber',
                FieldPrefix: 'EthosOpportunity',
                PropertyName: 'EthosOpportunity'
            },
            /** Relation: Wachter Team */
            EthosWachterTeam : {
                RelationName: 'JobNumber|WachterTeam|WachterTeamId',
                FieldPrefix: 'EthosWachterTeam',
                PropertyName: 'EthosWachterTeam'
            },
            /** Relation: Ethos Job */
            EthosJobByJobNumberId : {
                RelationName: 'JobToJobNumber',
                FieldPrefix: 'EthosJobJobNumberId',
                PropertyName: 'EthosJobJobNumberId'
            },
            /** Relation: Ethos Workflow Status - Job Number Status */
            EthosWorkflowStatusByJobNumberStatusWs : {
                RelationName: 'Ethos_WorkflowStatus|Ethos_JobNumber|JobNumberStatusWs',
                FieldPrefix: 'JobNumberStatusWsEthosWorkflowStatus',
                PropertyName: 'JobNumberStatusWsEthosWorkflowStatus'
            },
    };
}

class EthosJobNumberForecast implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_JobNumberForecast.';

    constructor() {
        this.ItemDetail.ItemId=2374;
        this.ItemDetail.ItemName='Ethos_JobNumberForecast';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    JobNumberForecastId : string = this.i + 'JobNumberForecastId';
    JobNumberId : string = this.i + 'JobNumberId';
    YeProjectedCosts : string = this.i + 'YeProjectedCosts';
    YeProjectedRevenue : string = this.i + 'YeProjectedRevenue';
    IsDeleted : string = this.i + 'IsDeleted';
    CreatedBy : string = this.i + 'CreatedBy';
    ModifiedBy : string = this.i + 'ModifiedBy';
    CreatedDateTime : string = this.i + 'CreatedDateTime';
    ModifiedDateTime : string = this.i + 'ModifiedDateTime';
    Notes : string = this.i + 'Notes';
    NoteAgingOverSixtyDays : string = this.i + 'NoteAgingOverSixtyDays';
    NoteOverUnderBilling : string = this.i + 'NoteOverUnderBilling';
    NoteLowForecastedGpm : string = this.i + 'NoteLowForecastedGpm';
    NoteChangedGpm : string = this.i + 'NoteChangedGpm';
    AXIntegrationID : string = this.i + 'AXIntegrationID';
    TotalForecastRevenue : string = this.i + 'TotalForecastRevenue';
    TotalForecastCost : string = this.i + 'TotalForecastCost';

    Relations = {
    };
}

class EthosJobNumberPhase implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_JobNumberPhase.';

    constructor() {
        this.ItemDetail.ItemId=2552;
        this.ItemDetail.ItemName='Ethos_JobNumberPhase';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    JobNumberPhaseId : string = this.i + 'JobNumberPhaseId';
    JobNumberId : string = this.i + 'JobNumberId';
    PhaseCode : string = this.i + 'PhaseCode';
    PhaseDescription : string = this.i + 'PhaseDescription';
    IsActive : string = this.i + 'IsActive';
    IsVisible : string = this.i + 'IsVisible';
    IsOnSite : string = this.i + 'IsOnSite';
    IsEstimate : string = this.i + 'IsEstimate';
    JobNumberPhaseStatusWs : string = this.i + 'JobNumberPhaseStatusWs';
    WorkflowStatusDisplay : string = this.i + 'WorkflowStatusDisplay';

    Relations = {
            /** Relation: Ethos Workflow Status - Job Number Phase Status */
            EthosWorkflowStatusByJobNumberPhaseStatusWs : {
                RelationName: 'Ethos_WorkflowStatus|Ethos_JobNumberPhase|JobNumberPhaseStatusWs',
                FieldPrefix: 'JobNumberPhaseStatusWsEthosWorkflowStatus',
                PropertyName: 'JobNumberPhaseStatusWsEthosWorkflowStatus'
            },
    };
}

class EthosJobSite implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_JobSite.';

    constructor() {
        this.ItemDetail.ItemId=2636;
        this.ItemDetail.ItemName='Ethos_JobSite';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    JobSiteId : string = this.i + 'JobSiteId';
    JobId : string = this.i + 'JobId';
    SiteId : string = this.i + 'SiteId';
    IsDeleted : string = this.i + 'IsDeleted';
    LookUpKey : string = this.i + 'LookUpKey';
    SubJobNumber : string = this.i + 'SubJobNumber';
    FullJobNumber : string = this.i + 'FullJobNumber';

    Relations = {
            /** Relation: Permit Request */
            PermitRequest : {
                RelationName: 'Ethos_JobSite|PermitRequest|JobSiteId',
                FieldPrefix: 'PermitRequest',
                PropertyName: 'PermitRequest'
            },
            /** Relation: Ethos Job Sow */
            EthosJobSow : {
                RelationName: 'Ethos_JobSite|Ethos_JobSow|JobSiteId',
                FieldPrefix: 'EthosJobSow',
                PropertyName: 'EthosJobSow'
            },
            /** Relation: Permit */
            Permit : {
                RelationName: 'Ethos_JobSite|Permit|JobSiteId',
                FieldPrefix: 'Permit',
                PropertyName: 'Permit'
            },
            /** Relation: Ethos Job */
            EthosJobByJobId : {
                RelationName: 'Job Site -> Job',
                FieldPrefix: 'EthosJobJobId',
                PropertyName: 'EthosJobJobId'
            },
            /** Relation: Ethos Job */
            EthosJob : {
                RelationName: 'Ethos_Job|Ethos_JobSite|JobId',
                FieldPrefix: 'EthosJob',
                PropertyName: 'EthosJob'
            },
    };
}

class EthosJobSow implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_JobSow.';

    constructor() {
        this.ItemDetail.ItemId=2637;
        this.ItemDetail.ItemName='Ethos_JobSow';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    JobSowId : string = this.i + 'JobSowId';
    SowId : string = this.i + 'SowId';
    JobId : string = this.i + 'JobId';
    JobSiteId : string = this.i + 'JobSiteId';

    Relations = {
            /** Relation: Ethos Job Site */
            EthosJobSite : {
                RelationName: 'Ethos_JobSite|Ethos_JobSow|JobSiteId',
                FieldPrefix: 'EthosJobSite',
                PropertyName: 'EthosJobSite'
            },
            /** Relation: Ethos Job */
            EthosJob : {
                RelationName: 'Ethos_Job|Ethos_JobSow|JobId',
                FieldPrefix: 'EthosJob',
                PropertyName: 'EthosJob'
            },
    };
}

class EthosOpportunity implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_Opportunity.';

    constructor() {
        this.ItemDetail.ItemId=2693;
        this.ItemDetail.ItemName='Ethos_Opportunity';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    OpportunityId : string = this.i + 'OpportunityId';
    OpportunityStatusWs : string = this.i + 'OpportunityStatusWs';
    OpportunityName : string = this.i + 'OpportunityName';
    CustomerId : string = this.i + 'CustomerId';

    Relations = {
            /** Relation: Job Number */
            EthosJobNumber : {
                RelationName: 'OpportunityToJobNumber',
                FieldPrefix: 'EthosJobNumber',
                PropertyName: 'EthosJobNumber'
            },
            /** Relation: Ethos Workflow Status - Opportunity Status */
            EthosWorkflowStatusByOpportunityStatusWs : {
                RelationName: 'Ethos_WorkflowStatus|Ethos_Opportunity|OpportunityStatusWs',
                FieldPrefix: 'OpportunityStatusWsEthosWorkflowStatus',
                PropertyName: 'OpportunityStatusWsEthosWorkflowStatus'
            },
            /** Relation: Permit Request */
            PermitRequest : {
                RelationName: 'Ethos_Opportunity|permitRequest|OpportunityId',
                FieldPrefix: 'PermitRequest',
                PropertyName: 'PermitRequest'
            },
    };
}

class EthosUser implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_User.';

    constructor() {
        this.ItemDetail.ItemId=2413;
        this.ItemDetail.ItemName='Ethos_User';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    UserName : string = this.i + 'UserName';
    FirstName : string = this.i + 'FirstName';
    LastName : string = this.i + 'LastName';
    MiddleName : string = this.i + 'MiddleName';
    PreferredName : string = this.i + 'PreferredName';
    Suffix : string = this.i + 'Suffix';
    OfficePhone : string = this.i + 'OfficePhone';
    MobilePhone : string = this.i + 'MobilePhone';
    WachterJobTitleId : string = this.i + 'WachterJobTitleId';
    WachterJobTitle : string = this.i + 'WachterJobTitle';
    UserTypeCv : string = this.i + 'UserTypeCv';
    UserTypeDisplay : string = this.i + 'UserTypeDisplay';
    StaffingAgencyId : string = this.i + 'StaffingAgencyId';
    ResourceGroupCv : string = this.i + 'ResourceGroupCv';
    ResourceGroup : string = this.i + 'ResourceGroup';
    EmployeeGroupId : string = this.i + 'EmployeeGroupId';
    EmployeeGroupCode : string = this.i + 'EmployeeGroupCode';
    EmployeeGroupDescription : string = this.i + 'EmployeeGroupDescription';
    EmpHireDate : string = this.i + 'empHireDate';
    AddressLongitude : string = this.i + 'AddressLongitude';
    AddressLatitude : string = this.i + 'AddressLatitude';
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    BirthMonth : string = this.i + 'BirthMonth';
    BirthDate : string = this.i + 'BirthDate';
    Email : string = this.i + 'Email';
    SupervisorUserId : string = this.i + 'SupervisorUserId';
    UserStatusWs : string = this.i + 'UserStatusWs';
    UserStatusMeaning : string = this.i + 'UserStatusMeaning';
    IsTerminated : string = this.i + 'IsTerminated';
    PictureAttachmentFileExtension : string = this.i + 'PictureAttachmentFileExtension';
    PictureAttachmentDisplay : string = this.i + 'PictureAttachmentDisplay';
    PictureAttachmentField : string = this.i + 'PictureAttachmentField';
    AdjustedStartDate : string = this.i + 'AdjustedStartDate';
    OfficeId : string = this.i + 'OfficeId';
    OfficeName : string = this.i + 'OfficeName';
    StreetAddress1 : string = this.i + 'StreetAddress1';
    StreetAddress2 : string = this.i + 'StreetAddress2';
    City : string = this.i + 'City';
    StateProvinceShortName : string = this.i + 'StateProvinceShortName';
    PostalCode : string = this.i + 'PostalCode';
    HasVehicle : string = this.i + 'HasVehicle';
    ShowUserOnMap : string = this.i + 'ShowUserOnMap';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';
    EmployeeType : string = this.i + 'EmployeeType';
    StateProvinceId : string = this.i + 'StateProvinceId';
    PictureAttachmentFileKey : string = this.i + 'PictureAttachmentFileKey';
    CustomerId : string = this.i + 'CustomerId';
    SubcontractorId : string = this.i + 'SubcontractorId';
    SpecialInstructions : string = this.i + 'SpecialInstructions';
    IsVaxxed : string = this.i + 'isVaxxed';

    Relations = {
            /** Relation: Permit - Modified By - Many */
            PermitByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|Permit|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosPermit',
                PropertyName: 'ModifiedByEthosPermit'
            },
            /** Relation: Permit Request - Requested By - Many */
            PermitRequestByRequestedByUserId : {
                RelationName: 'Ethos_User|permitRequest|RequestedByUserId',
                FieldPrefix: 'RequestedByPermitRequest',
                PropertyName: 'RequestedByPermitRequest'
            },
            /** Relation: Ethos Code Value - User Type */
            EthosCodeValueByUserTypeCv : {
                RelationName: 'Ethos_CodeValue|Ethos_User|UserTypeCv',
                FieldPrefix: 'UserTypeCvEthosCodeValue',
                PropertyName: 'UserTypeCvEthosCodeValue'
            },
            /** Relation: Ethos Workflow Status - User Status */
            EthosWorkflowStatusByUserStatusWs : {
                RelationName: 'Ethos_WorkflowStatus|Ethos_User|UserStatusWs',
                FieldPrefix: 'UserStatusWsEthosWorkflowStatus',
                PropertyName: 'UserStatusWsEthosWorkflowStatus'
            },
            /** Relation: Ethos User - Supervisor User - Many */
            EthosUserBySupervisorUserId : {
                RelationName: 'Supervisor_User2',
                FieldPrefix: 'SupervisorEthosUser',
                PropertyName: 'SupervisorEthosUser'
            },
            /** Relation: Required Cable - Modified By - Many */
            RequiredCableByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|RequiredCable|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosRequiredCable',
                PropertyName: 'ModifiedByEthosRequiredCable'
            },
            /** Relation: Wachter Department */
            EthosWachterDepartment : {
                RelationName: 'Ethos_User|Ethos_WachterDepartment|DepartmentId',
                FieldPrefix: 'EthosWachterDepartment',
                PropertyName: 'EthosWachterDepartment'
            },
            /** Relation: Required Cable - Created By - Many */
            RequiredCableByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|RequiredCable|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosRequiredCable',
                PropertyName: 'CreatedByEthosRequiredCable'
            },
            /** Relation: Inspection - Created By - Many */
            InspectionByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|Inspection|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosInspection',
                PropertyName: 'CreatedByEthosInspection'
            },
            /** Relation: Permit - Assigned To User - Many */
            PermitByAssignedToUser : {
                RelationName: 'Ethos_User|Permit|AssignedToUser',
                FieldPrefix: 'AssignedToUserPermit',
                PropertyName: 'AssignedToUserPermit'
            },
            /** Relation: Permit Request - Assigned To - Many */
            PermitRequestByAssignedToUserId : {
                RelationName: 'Ethos_User|permitRequest|AssignedToUserId',
                FieldPrefix: 'AssignedToPermitRequest',
                PropertyName: 'AssignedToPermitRequest'
            },
            /** Relation: Access Control - Modified By - Many */
            AccessControlByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|AccessControl|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosAccessControl',
                PropertyName: 'ModifiedByEthosAccessControl'
            },
            /** Relation: Permit Request - Secondary Assigned To - Many */
            PermitRequestBySecondaryAssignedToUserId : {
                RelationName: 'Ethos_User|permitRequest|SecondaryAssignedToUserId',
                FieldPrefix: 'SecondaryAssignedToPermitRequest',
                PropertyName: 'SecondaryAssignedToPermitRequest'
            },
            /** Relation: Access Control - Created By - Many */
            AccessControlByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|AccessControl|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosAccessControl',
                PropertyName: 'CreatedByEthosAccessControl'
            },
            /** Relation: Ro Ethos User */
            RoEthosUser : {
                RelationName: 'Ethos_User|roEthos_User|UserId',
                FieldPrefix: 'RoEthosUser',
                PropertyName: 'RoEthosUser'
            },
            /** Relation: Permit Request - Created By - Many */
            PermitRequestByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|permitRequest|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosPermitRequest',
                PropertyName: 'CreatedByEthosPermitRequest'
            },
            /** Relation: Permit - Created By - Many */
            PermitByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|Permit|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosPermit',
                PropertyName: 'CreatedByEthosPermit'
            },
            /** Relation: Inspection - Technician - Many */
            InspectionByTechnicianUserId : {
                RelationName: 'Ethos_User|Inspection|TechnicianUserId',
                FieldPrefix: 'TechnicianInspection',
                PropertyName: 'TechnicianInspection'
            },
            /** Relation: Permit - Requested By User - Many */
            PermitByRequestedByUser : {
                RelationName: 'Ethos_User|Permit|RequestedByUser',
                FieldPrefix: 'RequestedByUserPermit',
                PropertyName: 'RequestedByUserPermit'
            },
            /** Relation: Job Number - User Id */
            EthosJobNumberByUserId : {
                RelationName: 'JobNumber->ProjectManager',
                FieldPrefix: 'UserIdEthosJobNumber',
                PropertyName: 'UserIdEthosJobNumber'
            },
            /** Relation: Permit Request - Modified By - Many */
            PermitRequestByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|permitRequest|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosPermitRequest',
                PropertyName: 'ModifiedByEthosPermitRequest'
            },
    };
}

class EthosUserDiff implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_UserDiff.';

    constructor() {
        this.ItemDetail.ItemId=2572;
        this.ItemDetail.ItemName='Ethos_UserDiff';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EthosUserDiffId : string = this.i + 'Ethos_UserDiffId';
    EthosUserId : string = this.i + 'Ethos_UserId';
    FieldName : string = this.i + 'FieldName';
    OldValue : string = this.i + 'OldValue';
    NewValue : string = this.i + 'NewValue';
    ChangedDateTime : string = this.i + 'ChangedDateTime';

    Relations = {
    };
}

class EthosUserSkill implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_UserSkill.';

    constructor() {
        this.ItemDetail.ItemId=2410;
        this.ItemDetail.ItemName='Ethos_UserSkill';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserSkillId : string = this.i + 'UserSkillId';
    UserId : string = this.i + 'UserId';
    SkillCv : string = this.i + 'SkillCv';
    Dislay : string = this.i + 'Dislay';
    Meaning : string = this.i + 'Meaning';

    Relations = {
    };
}

class EthosWachterDepartment implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_WachterDepartment.';

    constructor() {
        this.ItemDetail.ItemId=2388;
        this.ItemDetail.ItemName='Ethos_WachterDepartment';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    DepartmentTypeCv : string = this.i + 'DepartmentTypeCv';
    DepartmentTypeMeaning : string = this.i + 'DepartmentTypeMeaning';
    WachterDivisionId : string = this.i + 'WachterDivisionId';
    DivisionName : string = this.i + 'DivisionName';
    DivisionShortName : string = this.i + 'DivisionShortName';
    DepartmentName : string = this.i + 'DepartmentName';
    DepartmentShortName : string = this.i + 'DepartmentShortName';
    DepartmentDirectorUserId : string = this.i + 'DepartmentDirectorUserId';
    IsDeleted : string = this.i + 'IsDeleted';
    DepartmentManagerUserId : string = this.i + 'DepartmentManagerUserId';
    DepartmentAsstManagerUserId : string = this.i + 'DepartmentAsstManagerUserId';
    JobNumberId : string = this.i + 'JobNumberId';
    AxIntegrationId : string = this.i + 'AxIntegrationId';
    JobNumberPhaseId : string = this.i + 'JobNumberPhaseId';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';

    Relations = {
            /** Relation: Wachter Team */
            EthosWachterTeam : {
                RelationName: 'Ethos_WachterDepartment|Ethos_WachterTeam|WachterDepartmentId',
                FieldPrefix: 'EthosWachterTeam',
                PropertyName: 'EthosWachterTeam'
            },
            /** Relation: Ethos User */
            EthosUser : {
                RelationName: 'Ethos_User|Ethos_WachterDepartment|DepartmentId',
                FieldPrefix: 'EthosUser',
                PropertyName: 'EthosUser'
            },
    };
}

class EthosWachterTeam implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_WachterTeam.';

    constructor() {
        this.ItemDetail.ItemId=2412;
        this.ItemDetail.ItemName='Ethos_WachterTeam';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    TeamTypeCv : string = this.i + 'TeamTypeCv';
    TeamTypeMeaning : string = this.i + 'TeamTypeMeaning';
    TeamName : string = this.i + 'TeamName';
    TeamLeaderUserId : string = this.i + 'TeamLeaderUserId';
    AxIntegrationId : string = this.i + 'AxIntegrationId';
    TeamShortName : string = this.i + 'TeamShortName';
    TeamNickName : string = this.i + 'TeamNickName';
    IsDeleted : string = this.i + 'IsDeleted';
    OverheadJobNumberId : string = this.i + 'OverheadJobNumberId';
    OverheadJobNumberPhaseId : string = this.i + 'OverheadJobNumberPhaseId';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';

    Relations = {
            /** Relation: Wachter Department */
            EthosWachterDepartment : {
                RelationName: 'Ethos_WachterDepartment|Ethos_WachterTeam|WachterDepartmentId',
                FieldPrefix: 'EthosWachterDepartment',
                PropertyName: 'EthosWachterDepartment'
            },
            /** Relation: Job Number */
            EthosJobNumber : {
                RelationName: 'JobNumber|WachterTeam|WachterTeamId',
                FieldPrefix: 'EthosJobNumber',
                PropertyName: 'EthosJobNumber'
            },
    };
}

class EthosWorkflowStatus implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_WorkflowStatus.';

    constructor() {
        this.ItemDetail.ItemId=2581;
        this.ItemDetail.ItemName='Ethos_WorkflowStatus';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    WorkflowStatusId : string = this.i + 'WorkflowStatusId';
    WorkflowStatusSetId : string = this.i + 'WorkflowStatusSetId';
    WorkflowStatus : string = this.i + 'WorkflowStatus';
    WorkflowStatusMeaning : string = this.i + 'WorkflowStatusMeaning';
    WorkflowStatusOrder : string = this.i + 'WorkflowStatusOrder';
    IsActive : string = this.i + 'IsActive';
    WorkflowStatusShortName : string = this.i + 'WorkflowStatusShortName';

    Relations = {
            /** Relation: Ethos Workflow Status Set */
            EthosWorkflowStatusSet : {
                RelationName: 'Ethos_WorkflowStatusSet|Ethos_WorkflowStatus|WorkflowStatusSetId',
                FieldPrefix: 'EthosWorkflowStatusSet',
                PropertyName: 'EthosWorkflowStatusSet'
            },
            /** Relation: Job Number - Job Number Status Ws - Many */
            EthosJobNumberByJobNumberStatusWs : {
                RelationName: 'Ethos_WorkflowStatus|Ethos_JobNumber|JobNumberStatusWs',
                FieldPrefix: 'JobNumberStatusWsEthosJobNumber',
                PropertyName: 'JobNumberStatusWsEthosJobNumber'
            },
            /** Relation: Ethos Opportunity - Opportunity Status Ws - Many */
            EthosOpportunityByOpportunityStatusWs : {
                RelationName: 'Ethos_WorkflowStatus|Ethos_Opportunity|OpportunityStatusWs',
                FieldPrefix: 'OpportunityStatusWsEthosOpportunity',
                PropertyName: 'OpportunityStatusWsEthosOpportunity'
            },
            /** Relation: Ethos User - User Status Ws - Many */
            EthosUserByUserStatusWs : {
                RelationName: 'Ethos_WorkflowStatus|Ethos_User|UserStatusWs',
                FieldPrefix: 'UserStatusWsEthosUser',
                PropertyName: 'UserStatusWsEthosUser'
            },
            /** Relation: Ethos Job Number Phase - Job Number Phase Status Ws - Many */
            EthosJobNumberPhaseByJobNumberPhaseStatusWs : {
                RelationName: 'Ethos_WorkflowStatus|Ethos_JobNumberPhase|JobNumberPhaseStatusWs',
                FieldPrefix: 'JobNumberPhaseStatusWsEthosJobNumberPhase',
                PropertyName: 'JobNumberPhaseStatusWsEthosJobNumberPhase'
            },
            /** Relation: Permit - Permit Status Ws - Many */
            PermitByPermitStatusWs : {
                RelationName: 'Ethos_WorkflowStatus|Permit|PermitStatusWs',
                FieldPrefix: 'PermitStatusWsPermit',
                PropertyName: 'PermitStatusWsPermit'
            },
            /** Relation: Ro Ethos User - User Status Ws - Many */
            RoEthosUserByUserStatusWs : {
                RelationName: 'Ethos_WorkflowStatus|roEthos_User|UserStatusWs',
                FieldPrefix: 'UserStatusWsRoEthosUser',
                PropertyName: 'UserStatusWsRoEthosUser'
            },
    };
}

class EthosWorkflowStatusSet implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_WorkflowStatusSet.';

    constructor() {
        this.ItemDetail.ItemId=2580;
        this.ItemDetail.ItemName='Ethos_WorkflowStatusSet';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    WorkflowStatusSetId : string = this.i + 'WorkflowStatusSetId';
    WorkflowStatusSetName : string = this.i + 'WorkflowStatusSetName';
    MetaDataItemId : string = this.i + 'MetaDataItemId';
    MetaDataAttributeId : string = this.i + 'MetaDataAttributeId';
    RelatedCodeSetId : string = this.i + 'RelatedCodeSetId';
    UseTransitions : string = this.i + 'UseTransitions';
    IsActive : string = this.i + 'IsActive';

    Relations = {
            /** Relation: Ethos Workflow Status */
            EthosWorkflowStatus : {
                RelationName: 'Ethos_WorkflowStatusSet|Ethos_WorkflowStatus|WorkflowStatusSetId',
                FieldPrefix: 'EthosWorkflowStatus',
                PropertyName: 'EthosWorkflowStatus'
            },
    };
}

class Inspection implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Inspection.';

    constructor() {
        this.ItemDetail.ItemId=2746;
        this.ItemDetail.ItemName='Inspection';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    InspectionId : string = this.i + 'InspectionId';
    InspectionType : string = this.i + 'InspectionType';
    TechnicianOnSite : string = this.i + 'TechnicianOnSite';
    TechnicianUserId : string = this.i + 'TechnicianUserId';
    AvailableDates : string = this.i + 'AvailableDates';
    PreferredTimeOfDayCv : string = this.i + 'PreferredTimeOfDayCv';
    AdditionalNotes : string = this.i + 'AdditionalNotes';
    PermitId : string = this.i + 'PermitId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    InspectionNotes : string = this.i + 'InspectionNotes';
    ScheduledDateTime : string = this.i + 'ScheduledDateTime';
    ScheduledNotes : string = this.i + 'ScheduledNotes';
    ResultCv : string = this.i + 'ResultCv';
    ResultDateTime : string = this.i + 'ResultDateTime';
    ResultNotes : string = this.i + 'ResultNotes';
    AdditionalInspectionNeeded : string = this.i + 'AdditionalInspectionNeeded';

    Relations = {
            /** Relation: Ethos User - Technician */
            EthosUserByTechnicianUserId : {
                RelationName: 'Ethos_User|Inspection|TechnicianUserId',
                FieldPrefix: 'TechnicianEthosUser',
                PropertyName: 'TechnicianEthosUser'
            },
            /** Relation: Ethos User - Created By Ethos User */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|Inspection|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
            /** Relation: Permit */
            Permit : {
                RelationName: 'Permit|Inspection|PermitId',
                FieldPrefix: 'Permit',
                PropertyName: 'Permit'
            },
            /** Relation: Trust Code Value - Preferred Time Of Day */
            CodeValueByPreferredTimeOfDayCv : {
                RelationName: 'CodeValue|Inspection|PreferredTimeOfDayCv',
                FieldPrefix: 'PreferredTimeOfDayCvCodeValue',
                PropertyName: 'PreferredTimeOfDayCvCodeValue'
            },
            /** Relation: Trust Code Value - Result */
            CodeValueByResultCv : {
                RelationName: 'CodeValue|Inspection|ResultCv',
                FieldPrefix: 'ResultCvCodeValue',
                PropertyName: 'ResultCvCodeValue'
            },
    };
}

class NoteType implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'NoteType.';

    constructor() {
        this.ItemDetail.ItemId=2732;
        this.ItemDetail.ItemName='NoteType';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    NoteTypeId : string = this.i + 'NoteTypeId';
    NoteType : string = this.i + 'NoteType';
    MetaDataLookupId : string = this.i + 'MetaDataLookupId';

    Relations = {
    };
}

class Permit implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Permit.';

    constructor() {
        this.ItemDetail.ItemId=2633;
        this.ItemDetail.ItemName='Permit';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PermitId : string = this.i + 'PermitId';
    RequestedByUser : string = this.i + 'RequestedByUser';
    PermitTypeCv : string = this.i + 'PermitTypeCv';
    DueDate : string = this.i + 'DueDate';
    ScopeOfWork : string = this.i + 'ScopeOfWork';
    InspectionRequestDate : string = this.i + 'InspectionRequestDate';
    InspectionCompleteDate : string = this.i + 'InspectionCompleteDate';
    WachterPermitNumber : string = this.i + 'WachterPermitNumber';
    PermitCost : string = this.i + 'PermitCost';
    PerformingWorkCv : string = this.i + 'PerformingWorkCv';
    SubcontractorLicense : string = this.i + 'SubcontractorLicense';
    AssignedToUser : string = this.i + 'AssignedToUser';
    FloorCount : string = this.i + 'FloorCount';
    FacilitySquareFeet : string = this.i + 'FacilitySquareFeet';
    BuildingPermitNumber : string = this.i + 'BuildingPermitNumber';
    UndergroundCablingPresent : string = this.i + 'UndergroundCablingPresent';
    CablingInConduitPresent : string = this.i + 'CablingInConduitPresent';
    GCPresent : string = this.i + 'GCPresent';
    GCName : string = this.i + 'GCName';
    PropertyOwnerName : string = this.i + 'PropertyOwnerName';
    CableTypeCv : string = this.i + 'CableTypeCv';
    PermitStatusWs : string = this.i + 'PermitStatusWs';
    JobId : string = this.i + 'JobId';
    PermitTeamCv : string = this.i + 'PermitTeamCv';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    AttachmentId : string = this.i + 'AttachmentId';
    CanBePulledOnline : string = this.i + 'CanBePulledOnline';
    PropertyOwnerCity : string = this.i + 'PropertyOwnerCity';
    PropertyOwnerStateId : string = this.i + 'PropertyOwnerStateId';
    PropertyOwnerPostalCode : string = this.i + 'PropertyOwnerPostalCode';
    JobSiteId : string = this.i + 'JobSiteId';
    SharepointId : string = this.i + 'SharepointId';
    PropertyOwnerAddress : string = this.i + 'PropertyOwnerAddress';
    NoteParentId : string = this.i + 'NoteParentId';
    PermitRequestid : string = this.i + 'PermitRequestid';
    OverallContractValuation : string = this.i + 'OverallContractValuation';
    PlenumOrRiserCv : string = this.i + 'PlenumOrRiserCv';
    CableQuantity : string = this.i + 'CableQuantity';
    HasCameras : string = this.i + 'HasCameras';
    CameraQuantity : string = this.i + 'CameraQuantity';
    HasSpeakers : string = this.i + 'HasSpeakers';
    SpeakerQuantity : string = this.i + 'SpeakerQuantity';
    InitiationDeviceQuantity : string = this.i + 'InitiationDeviceQuantity';
    NACQuantity : string = this.i + 'NACQuantity';
    SwappingOutPanel : string = this.i + 'SwappingOutPanel';
    OutletQuantity : string = this.i + 'OutletQuantity';
    HasCardReaders : string = this.i + 'HasCardReaders';
    CardReaderQuantity : string = this.i + 'CardReaderQuantity';
    HasPaging : string = this.i + 'HasPaging';
    AlarmPanelInstallation : string = this.i + 'AlarmPanelInstallation';
    DeviceType : string = this.i + 'DeviceType';
    OverallSOWValuation : string = this.i + 'OverallSOWValuation';
    TotalAmps : string = this.i + 'TotalAmps';
    ElectricalPanelQuantity : string = this.i + 'ElectricalPanelQuantity';
    CircuitQuantity : string = this.i + 'CircuitQuantity';
    AccessControlTypeCv : string = this.i + 'AccessControlTypeCv';
    AccessControlQuantity : string = this.i + 'AccessControlQuantity';
    AlarmPanelQuantity : string = this.i + 'AlarmPanelQuantity';
    FilesInSharepoint : string = this.i + 'FilesInSharepoint';
    CriticalPower : string = this.i + 'CriticalPower';
    RoomCount : string = this.i + 'RoomCount';
    IsNewFireSystem : string = this.i + 'IsNewFireSystem';
    CableTypeOtherName : string = this.i + 'CableTypeOtherName';
    ElectricalOutletTypeCv : string = this.i + 'ElectricalOutletTypeCv';
    ElectricalOtherOutletType : string = this.i + 'ElectricalOtherOutletType';
    IsLicensedTechnician : string = this.i + 'IsLicensedTechnician';
    TechnicianNameAndLicenseNumber : string = this.i + 'TechnicianNameAndLicenseNumber';
    ElectricalOtherWorkType : string = this.i + 'ElectricalOtherWorkType';
    ElectricalTotalVoltage : string = this.i + 'ElectricalTotalVoltage';
    IsTyingIntoFireAlarm : string = this.i + 'IsTyingIntoFireAlarm';
    AccessControlOther : string = this.i + 'AccessControlOther';
    FireAlarmDemoInstallCv : string = this.i + 'FireAlarmDemoInstallCv';
    FireAlarmInstallRadio : string = this.i + 'FireAlarmInstallRadio';
    DataVoiceUsingExisting : string = this.i + 'DataVoiceUsingExisting';
    DataVoiceReplacingCable : string = this.i + 'DataVoiceReplacingCable';
    DataVoiceNewCable : string = this.i + 'DataVoiceNewCable';
    CCTVUsingExisting : string = this.i + 'CCTVUsingExisting';
    CCTVReplacingCable : string = this.i + 'CCTVReplacingCable';
    CCTVNewCable : string = this.i + 'CCTVNewCable';
    CCTVOtherInstallType : string = this.i + 'CCTVOtherInstallType';
    ElectricalDifferentTypeCv : string = this.i + 'ElectricalDifferentTypeCv';
    ElectricalWorkTypeCv : string = this.i + 'ElectricalWorkTypeCv';
    ElectricalOtherDifferentType : string = this.i + 'ElectricalOtherDifferentType';
    CCTVInstallTypeCv : string = this.i + 'CCTVInstallTypeCv';
    InfoNeededNote : string = this.i + 'InfoNeededNote';
    EstimatedStartDate : string = this.i + 'EstimatedStartDate';
    EstimatedJobCompletionDate : string = this.i + 'EstimatedJobCompletionDate';
    FireAlarmAdditionalDevices : string = this.i + 'FireAlarmAdditionalDevices';
    PlenumRated : string = this.i + 'PlenumRated';
    WorkplaceSquareFeet : string = this.i + 'WorkplaceSquareFeet';
    ExpirationDate : string = this.i + 'ExpirationDate';
    NewConstruction : string = this.i + 'NewConstruction';
    ExistingBuilding : string = this.i + 'ExistingBuilding';
    FollowUpDate : string = this.i + 'FollowUpDate';
    Jurisdiction : string = this.i + 'Jurisdiction';
    FollowUpDescription : string = this.i + 'FollowUpDescription';
    InspectionStateCv : string = this.i + 'InspectionStateCv';

    Relations = {
            /** Relation: Permit Request - Permit Request */
            PermitRequestByPermitRequestid : {
                RelationName: 'permitRequest|Permit|PermitRequestid',
                FieldPrefix: 'PermitRequestidPermitRequest',
                PropertyName: 'PermitRequestidPermitRequest'
            },
            /** Relation: Ethos Code Value - Permit Type */
            EthosCodeValueByPermitTypeCv : {
                RelationName: 'Ethos_CodeValue|Permit|PermitTypeCv',
                FieldPrefix: 'PermitTypeCvEthosCodeValue',
                PropertyName: 'PermitTypeCvEthosCodeValue'
            },
            /** Relation: Ethos Code Value - Plenum Or Riser */
            EthosCodeValueByPlenumOrRiserCv : {
                RelationName: 'Ethos_CodeValue|Permit|PlenumOrRiserCv',
                FieldPrefix: 'PlenumOrRiserCvEthosCodeValue',
                PropertyName: 'PlenumOrRiserCvEthosCodeValue'
            },
            /** Relation: Trust Code Value - Electrical Different Type */
            CodeValueByElectricalDifferentTypeCv : {
                RelationName: 'CodeValue|Permit|ElectricalDifferentTypeCv',
                FieldPrefix: 'ElectricalDifferentTypeCvCodeValue',
                PropertyName: 'ElectricalDifferentTypeCvCodeValue'
            },
            /** Relation: Trust Code Value - Electrical Outlet Type */
            CodeValueByElectricalOutletTypeCv : {
                RelationName: 'CodeValue|Permit|ElectricalOutletTypeCv',
                FieldPrefix: 'ElectricalOutletTypeCvCodeValue',
                PropertyName: 'ElectricalOutletTypeCvCodeValue'
            },
            /** Relation: Access Control */
            AccessControl : {
                RelationName: 'Permit|AccessControl|PermitId',
                FieldPrefix: 'AccessControl',
                PropertyName: 'AccessControl'
            },
            /** Relation: Ethos Code Value - Permit Team */
            EthosCodeValueByPermitTeamCv : {
                RelationName: 'Ethos_CodeValue|Permit|PermitTeamCv',
                FieldPrefix: 'PermitTeamCvEthosCodeValue',
                PropertyName: 'PermitTeamCvEthosCodeValue'
            },
            /** Relation: Trust Code Value - Access Control Type */
            CodeValueByAccessControlTypeCv : {
                RelationName: 'CodeValue|Permit|AccessControlTypeCv',
                FieldPrefix: 'AccessControlTypeCvCodeValue',
                PropertyName: 'AccessControlTypeCvCodeValue'
            },
            /** Relation: Ethos User - Assigned To */
            EthosUserByAssignedToUser : {
                RelationName: 'Ethos_User|Permit|AssignedToUser',
                FieldPrefix: 'AssignedToUserEthosUser',
                PropertyName: 'AssignedToUserEthosUser'
            },
            /** Relation: Inspection */
            Inspection : {
                RelationName: 'Permit|Inspection|PermitId',
                FieldPrefix: 'Inspection',
                PropertyName: 'Inspection'
            },
            /** Relation: Trust Code Value - Fire Alarm Demo Install */
            CodeValueByFireAlarmDemoInstallCv : {
                RelationName: 'CodeValue|Permit|FireAlarmDemoInstallCv',
                FieldPrefix: 'FireAlarmDemoInstallCvCodeValue',
                PropertyName: 'FireAlarmDemoInstallCvCodeValue'
            },
            /** Relation: Trust Code Value - C C T V Install Type */
            CodeValueByCCTVInstallTypeCv : {
                RelationName: 'CodeValue|Permit|CCTVInstallTypeCv',
                FieldPrefix: 'CCTVInstallTypeCvCodeValue',
                PropertyName: 'CCTVInstallTypeCvCodeValue'
            },
            /** Relation: Permit Permit Type */
            PermitPermitType : {
                RelationName: 'Permit|PermitPermitType|PermitId',
                FieldPrefix: 'PermitPermitType',
                PropertyName: 'PermitPermitType'
            },
            /** Relation: Ethos User - Created By */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|Permit|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
            /** Relation: Ethos Code Value - Performing Work */
            EthosCodeValueByPerformingWorkCv : {
                RelationName: 'Ethos_CodeValue|Permit|PerformingWorkCv',
                FieldPrefix: 'PerformingWorkCvEthosCodeValue',
                PropertyName: 'PerformingWorkCvEthosCodeValue'
            },
            /** Relation: Trust Code Value - Electrical Work Type */
            CodeValueByElectricalWorkTypeCv : {
                RelationName: 'CodeValue|Permit|ElectricalWorkTypeCv',
                FieldPrefix: 'ElectricalWorkTypeCvCodeValue',
                PropertyName: 'ElectricalWorkTypeCvCodeValue'
            },
            /** Relation: Ethos Code Value - Cable Type */
            EthosCodeValueByCableTypeCv : {
                RelationName: 'Ethos_CodeValue|Permit|CableTypeCv',
                FieldPrefix: 'CableTypeCvEthosCodeValue',
                PropertyName: 'CableTypeCvEthosCodeValue'
            },
            /** Relation: Ethos Workflow Status - Permit Status */
            EthosWorkflowStatusByPermitStatusWs : {
                RelationName: 'Ethos_WorkflowStatus|Permit|PermitStatusWs',
                FieldPrefix: 'PermitStatusWsEthosWorkflowStatus',
                PropertyName: 'PermitStatusWsEthosWorkflowStatus'
            },
            /** Relation: Permit Request Permit */
            PermitRequestPermit : {
                RelationName: 'Permit|PermitRequests|PermitId',
                FieldPrefix: 'PermitRequestPermit',
                PropertyName: 'PermitRequestPermit'
            },
            /** Relation: Ethos User - Modified By */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|Permit|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Required Cable */
            RequiredCable : {
                RelationName: 'Permit|RequiredCable|PermitId',
                FieldPrefix: 'RequiredCable',
                PropertyName: 'RequiredCable'
            },
            /** Relation: Trust Code Value - Inspection State */
            CodeValueByInspectionStateCv : {
                RelationName: 'CodeValue|Permit|InspectionStateCv',
                FieldPrefix: 'InspectionStateCvCodeValue',
                PropertyName: 'InspectionStateCvCodeValue'
            },
            /** Relation: Ethos Job Site */
            EthosJobSite : {
                RelationName: 'Ethos_JobSite|Permit|JobSiteId',
                FieldPrefix: 'EthosJobSite',
                PropertyName: 'EthosJobSite'
            },
            /** Relation: Trust Code Value - Cable Type */
            CodeValueByCableTypeCv : {
                RelationName: 'CodeValue|Permit|CableTypeCv',
                FieldPrefix: 'CableTypeCvCodeValue',
                PropertyName: 'CableTypeCvCodeValue'
            },
            /** Relation: Ro Permits */
            RoPermits : {
                RelationName: 'roPermit}Permit|PermitId',
                FieldPrefix: 'RoPermits',
                PropertyName: 'RoPermits'
            },
            /** Relation: Ethos Job */
            EthosJob : {
                RelationName: 'Ethos_Job|Permit|JobId',
                FieldPrefix: 'EthosJob',
                PropertyName: 'EthosJob'
            },
            /** Relation: Permit Request - Data Cable - Many */
            PermitRequestByDataCablePermitId : {
                RelationName: 'Permit|permitRequest|DataCablePermitId',
                FieldPrefix: 'DataCablePermitRequest',
                PropertyName: 'DataCablePermitRequest'
            },
            /** Relation: Ro Inspections */
            RoInspections : {
                RelationName: 'roInspections|Permit|PermitId',
                FieldPrefix: 'RoInspections',
                PropertyName: 'RoInspections'
            },
            /** Relation: Ethos User - Requested By */
            EthosUserByRequestedByUser : {
                RelationName: 'Ethos_User|Permit|RequestedByUser',
                FieldPrefix: 'RequestedByUserEthosUser',
                PropertyName: 'RequestedByUserEthosUser'
            },
    };
}

class PermitPermitType implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'PermitPermitType.';

    constructor() {
        this.ItemDetail.ItemId=2678;
        this.ItemDetail.ItemName='PermitPermitType';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PermitPermitTypeId : string = this.i + 'PermitPermitTypeId';
    PermitId : string = this.i + 'PermitId';
    PermitTypeCv : string = this.i + 'PermitTypeCv';

    Relations = {
            /** Relation: Trust Code Value - Permit Type */
            CodeValueByPermitTypeCv : {
                RelationName: 'CodeValue|PermitPermitTypeOld|PermitTypeCv',
                FieldPrefix: 'PermitTypeCvCodeValue',
                PropertyName: 'PermitTypeCvCodeValue'
            },
            /** Relation: Permit */
            Permit : {
                RelationName: 'Permit|PermitPermitType|PermitId',
                FieldPrefix: 'Permit',
                PropertyName: 'Permit'
            },
            /** Relation: Ethos Code Value - Permit Type */
            EthosCodeValueByPermitTypeCv : {
                RelationName: 'Ethos_CodeValue|PermitPermitType|PermitTypeCv',
                FieldPrefix: 'PermitTypeCvEthosCodeValue',
                PropertyName: 'PermitTypeCvEthosCodeValue'
            },
    };
}

class PermitRequest implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'permitRequest.';

    constructor() {
        this.ItemDetail.ItemId=2613;
        this.ItemDetail.ItemName='permitRequest';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PermitRequestId : string = this.i + 'PermitRequestId';
    RequestedByUserId : string = this.i + 'RequestedByUserId';
    PermitTypeCv : string = this.i + 'PermitTypeCv';
    StatusCv : string = this.i + 'StatusCv';
    DueDate : string = this.i + 'DueDate';
    WJID : string = this.i + 'WJID';
    ScopeOfWork : string = this.i + 'ScopeOfWork';
    PulledOnline : string = this.i + 'PulledOnline';
    InspectionRequestDate : string = this.i + 'InspectionRequestDate';
    InspectionCompleteDate : string = this.i + 'InspectionCompleteDate';
    WachterPermitNumber : string = this.i + 'WachterPermitNumber';
    Valuation : string = this.i + 'Valuation';
    PermitCost : string = this.i + 'PermitCost';
    PerformingWorkCv : string = this.i + 'PerformingWorkCv';
    SubLicenseNumber : string = this.i + 'SubLicenseNumber';
    PermitTeamCv : string = this.i + 'PermitTeamCv';
    AssignedToUserId : string = this.i + 'AssignedToUserId';
    NumberOfFloors : string = this.i + 'NumberOfFloors';
    FacilitySquareFeet : string = this.i + 'FacilitySquareFeet';
    PlenumOrRiser : string = this.i + 'PlenumOrRiser';
    BuildingPermitNumber : string = this.i + 'BuildingPermitNumber';
    UndergroundCabling : string = this.i + 'UndergroundCabling';
    CablingInConduit : string = this.i + 'CablingInConduit';
    GCName : string = this.i + 'GCName';
    PropertyOwnerName : string = this.i + 'PropertyOwnerName';
    Address : string = this.i + 'Address';
    City : string = this.i + 'City';
    StateProvinceId : string = this.i + 'StateProvinceId';
    Zipcode : string = this.i + 'Zipcode';
    AttachmentId : string = this.i + 'AttachmentId';
    JobSiteId : string = this.i + 'JobSiteId';
    CableTypeCv : string = this.i + 'CableTypeCv';
    ConstructionType : string = this.i + 'ConstructionType';
    JobId : string = this.i + 'JobId';
    OpportunityId : string = this.i + 'OpportunityId';
    DataCableQuantity : string = this.i + 'DataCableQuantity';
    HasCameras : string = this.i + 'HasCameras';
    CamerasQuantity : string = this.i + 'CamerasQuantity';
    HasSpeakers : string = this.i + 'HasSpeakers';
    SpeakersQuantity : string = this.i + 'SpeakersQuantity';
    HasFireAlarm : string = this.i + 'HasFireAlarm';
    NumberAditionalDevices : string = this.i + 'NumberAditionalDevices';
    NumberNaNC : string = this.i + 'NumberNaNC';
    IsSwappingOutPanel : string = this.i + 'IsSwappingOutPanel';
    HasElectrical : string = this.i + 'HasElectrical';
    OutletQuantity : string = this.i + 'OutletQuantity';
    TotalAmps : string = this.i + 'TotalAmps';
    PanelsQuantity : string = this.i + 'PanelsQuantity';
    CircuitsQuantity : string = this.i + 'CircuitsQuantity';
    HasAccessControl : string = this.i + 'HasAccessControl';
    AccessControlCV : string = this.i + 'AccessControlCV';
    AccessControlQuantity : string = this.i + 'AccessControlQuantity';
    CardReader : string = this.i + 'CardReader';
    CardReaderQuantity : string = this.i + 'CardReaderQuantity';
    Paging : string = this.i + 'Paging';
    HasPanelInstalation : string = this.i + 'HasPanelInstalation';
    BuglarAlarmPanelQuantity : string = this.i + 'BuglarAlarmPanelQuantity';
    BuglarAlarmDeviceType : string = this.i + 'BuglarAlarmDeviceType';
    PerformWork : string = this.i + 'PerformWork';
    SubContractorLicenseNumber : string = this.i + 'SubContractorLicenseNumber';
    SpecificDescription : string = this.i + 'SpecificDescription';
    NumberOfRooms : string = this.i + 'NumberOfRooms';
    FacilitySquareFootage : string = this.i + 'FacilitySquareFootage';
    WorkspaceSquareFootage : string = this.i + 'WorkspaceSquareFootage';
    PlenumRiser : string = this.i + 'PlenumRiser';
    HasUndergroundCabling : string = this.i + 'HasUndergroundCabling';
    HasCableInConduit : string = this.i + 'HasCableInConduit';
    ValuationOverallContract : string = this.i + 'ValuationOverallContract';
    ValuationOverallSOW : string = this.i + 'ValuationOverallSOW';
    ExpectedStartDate : string = this.i + 'ExpectedStartDate';
    ExpectedCompletion : string = this.i + 'ExpectedCompletion';
    PermitRequestTypeCv : string = this.i + 'PermitRequestTypeCv';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    DataCablePermitId : string = this.i + 'DataCablePermitId';
    SecondaryAssignedToUserId : string = this.i + 'SecondaryAssignedToUserId';
    CriticalPower : string = this.i + 'CriticalPower';
    JobSiteAddress1 : string = this.i + 'JobSiteAddress1';
    JobSiteAddress2 : string = this.i + 'JobSiteAddress2';
    CountyId : string = this.i + 'CountyId';
    PostalCode : string = this.i + 'PostalCode';
    PermitRequestJobType : string = this.i + 'PermitRequestJobType';
    GCPresent : string = this.i + 'GCPresent';
    HasAudioVisual : string = this.i + 'HasAudioVisual';
    HasBurglarAlarm : string = this.i + 'HasBurglarAlarm';
    VoiceDataCableTypeCV : string = this.i + 'VoiceDataCableTypeCV';
    VoiceDataQuantity : string = this.i + 'VoiceDataQuantity';
    VoiceDataPlenumRated : string = this.i + 'VoiceDataPlenumRated';
    HasCCTV : string = this.i + 'HasCCTV';
    CCTVCableTypeCV : string = this.i + 'CCTVCableTypeCV';
    CCTVQuantity : string = this.i + 'CCTVQuantity';
    CCTVPlenumRated : string = this.i + 'CCTVPlenumRated';
    HasAudio : string = this.i + 'HasAudio';
    AudioCableTypeCV : string = this.i + 'AudioCableTypeCV';
    AudioQuantity : string = this.i + 'AudioQuantity';
    AudioPlenumRated : string = this.i + 'AudioPlenumRated';
    IsNewFireSystem : string = this.i + 'IsNewFireSystem';
    HasDataVoice : string = this.i + 'HasDataVoice';
    GCPermitNumber : string = this.i + 'GCPermitNumber';
    FloorCount : string = this.i + 'FloorCount';
    DataVoiceOtherCable : string = this.i + 'DataVoiceOtherCable';
    CCTVOtherCable : string = this.i + 'CCTVOtherCable';
    AudioVisualOtherCable : string = this.i + 'AudioVisualOtherCable';
    NoteParentId : string = this.i + 'NoteParentId';
    ElectricalOutletTypeCv : string = this.i + 'ElectricalOutletTypeCv';
    ElectricalOtherOutletType : string = this.i + 'ElectricalOtherOutletType';
    IsLicensedTechnician : string = this.i + 'IsLicensedTechnician';
    TechnicianNameAndLicenseNumber : string = this.i + 'TechnicianNameAndLicenseNumber';
    ElectricalOtherWorkType : string = this.i + 'ElectricalOtherWorkType';
    ElectricalTotalVoltage : string = this.i + 'ElectricalTotalVoltage';
    IsTyingIntoFireAlarm : string = this.i + 'IsTyingIntoFireAlarm';
    FireAlarmInitiatingDevices : string = this.i + 'FireAlarmInitiatingDevices';
    FireAlarmDemoInstallCv : string = this.i + 'FireAlarmDemoInstallCv';
    DataVoiceUsingExisting : string = this.i + 'DataVoiceUsingExisting';
    DataVoiceReplacingCable : string = this.i + 'DataVoiceReplacingCable';
    DataVoiceNewCable : string = this.i + 'DataVoiceNewCable';
    CCTVUsingExisting : string = this.i + 'CCTVUsingExisting';
    CCTVReplacingCable : string = this.i + 'CCTVReplacingCable';
    CCTVNewCable : string = this.i + 'CCTVNewCable';
    CCTVInstallTypeCv : string = this.i + 'CCTVInstallTypeCv';
    CCTVOtherInstallType : string = this.i + 'CCTVOtherInstallType';
    ElectricalDifferentTypeCv : string = this.i + 'ElectricalDifferentTypeCv';
    ElectricalWorkTypeCv : string = this.i + 'ElectricalWorkTypeCv';
    AccessControlOther : string = this.i + 'AccessControlOther';
    AccessControlOtherTypeCv : string = this.i + 'AccessControlOtherTypeCv';
    ElectricalOtherDifferentType : string = this.i + 'ElectricalOtherDifferentType';
    FireAlarmInstallRadio : string = this.i + 'FireAlarmInstallRadio';
    IsLicenceRequired : string = this.i + 'IsLicenceRequired';
    HasLicenseFile : string = this.i + 'HasLicenseFile';
    WorkplaceSquareFeet : string = this.i + 'WorkplaceSquareFeet';
    FollowUpDate : string = this.i + 'FollowUpDate';
    RushRequested : string = this.i + 'RushRequested';
    RequestCompleteDate : string = this.i + 'RequestCompleteDate';
    NewConstruction : string = this.i + 'NewConstruction';
    ExistingBuilding : string = this.i + 'ExistingBuilding';
    Jurisdiction : string = this.i + 'Jurisdiction';
    FollowUpDescription : string = this.i + 'FollowUpDescription';

    Relations = {
            /** Relation: Ethos Code Value - Permit Type (NOT USED) */
            EthosCodeValueByPermitTypeCv : {
                RelationName: 'Ethos_CodeValue|permitRequest|PermitTypeCv',
                FieldPrefix: 'PermitTypeCvEthosCodeValue',
                PropertyName: 'PermitTypeCvEthosCodeValue'
            },
            /** Relation: Ethos Job - WJID (NOT USED) */
            EthosJobByWJID : {
                RelationName: 'Job|PermitRequest|JobId',
                FieldPrefix: 'WJIDEthosJob',
                PropertyName: 'WJIDEthosJob'
            },
            /** Relation: Trust Code Value - Permit Request Type */
            CodeValueByPermitRequestTypeCv : {
                RelationName: 'CodeValue|permitRequest|PermitRequestTypeCv',
                FieldPrefix: 'PermitRequestTypeCvCodeValue',
                PropertyName: 'PermitRequestTypeCvCodeValue'
            },
            /** Relation: Required Cable */
            RequiredCable : {
                RelationName: 'permitRequest|RequiredCable|PermitRequestId',
                FieldPrefix: 'RequiredCable',
                PropertyName: 'RequiredCable'
            },
            /** Relation: Trust Code Value - Type of Install */
            CodeValueByCCTVInstallTypeCv : {
                RelationName: 'CodeValue|permitRequest|CCTVInstallTypeCv',
                FieldPrefix: 'CCTVInstallTypeCvCodeValue',
                PropertyName: 'CCTVInstallTypeCvCodeValue'
            },
            /** Relation: Permit Request Permit Type */
            PermitRequestPermitType : {
                RelationName: 'permitRequest|PermitRequestPermitType|PermitRequestId',
                FieldPrefix: 'PermitRequestPermitType',
                PropertyName: 'PermitRequestPermitType'
            },
            /** Relation: Trust Code Value - Work Type */
            CodeValueByElectricalWorkTypeCv : {
                RelationName: 'CodeValue|permitRequest|ElectricalWorkTypeCv',
                FieldPrefix: 'ElectricalWorkTypeCvCodeValue',
                PropertyName: 'ElectricalWorkTypeCvCodeValue'
            },
            /** Relation: Permit - Request ID - Many */
            PermitByPermitRequestid : {
                RelationName: 'permitRequest|Permit|PermitRequestid',
                FieldPrefix: 'PermitRequestidPermit',
                PropertyName: 'PermitRequestidPermit'
            },
            /** Relation: Trust Code Value - Status */
            CodeValueByStatusCv : {
                RelationName: 'CodeValue|permitRequest|StatusCv',
                FieldPrefix: 'StatusCvCodeValue',
                PropertyName: 'StatusCvCodeValue'
            },
            /** Relation: Ethos Job */
            EthosJob : {
                RelationName: 'Ethos_Job|permitRequest|JobId',
                FieldPrefix: 'EthosJob',
                PropertyName: 'EthosJob'
            },
            /** Relation: Trust Code Value - Outlet Type */
            CodeValueByElectricalOutletTypeCv : {
                RelationName: 'CodeValue|permitRequest|ElectricalOutletTypeCv',
                FieldPrefix: 'ElectricalOutletTypeCvCodeValue',
                PropertyName: 'ElectricalOutletTypeCvCodeValue'
            },
            /** Relation: Ethos User - Created By Ethos User */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|permitRequest|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|permitRequest|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Ro Permit Requests */
            RoPermitRequests : {
                RelationName: 'roPermitRequests|permitRequest|PermitRequestId',
                FieldPrefix: 'RoPermitRequests',
                PropertyName: 'RoPermitRequests'
            },
            /** Relation: Ethos User - Secondary Assigned To */
            EthosUserBySecondaryAssignedToUserId : {
                RelationName: 'Ethos_User|permitRequest|SecondaryAssignedToUserId',
                FieldPrefix: 'SecondaryAssignedToEthosUser',
                PropertyName: 'SecondaryAssignedToEthosUser'
            },
            /** Relation: Ethos User - Assigned To */
            EthosUserByAssignedToUserId : {
                RelationName: 'Ethos_User|permitRequest|AssignedToUserId',
                FieldPrefix: 'AssignedToEthosUser',
                PropertyName: 'AssignedToEthosUser'
            },
            /** Relation: Permit Request Permit */
            PermitRequestPermit : {
                RelationName: 'permitRequest|PermitRequestPermit|PermitRequestId',
                FieldPrefix: 'PermitRequestPermit',
                PropertyName: 'PermitRequestPermit'
            },
            /** Relation: Ethos Code Value - Plenum or Riser */
            EthosCodeValueByPlenumRiser : {
                RelationName: 'Ethos_CodeValue|permitRequest|PlenumRiser',
                FieldPrefix: 'PlenumRiserEthosCodeValue',
                PropertyName: 'PlenumRiserEthosCodeValue'
            },
            /** Relation: Permit - Data Cable Permit */
            PermitByDataCablePermitId : {
                RelationName: 'Permit|permitRequest|DataCablePermitId',
                FieldPrefix: 'DataCablePermit',
                PropertyName: 'DataCablePermit'
            },
            /** Relation: Trust Code Value - Different Types of Electrical */
            CodeValueByElectricalDifferentTypeCv : {
                RelationName: 'CodeValue|permitRequest|ElectricalDifferentTypeCv',
                FieldPrefix: 'ElectricalDifferentTypeCvCodeValue',
                PropertyName: 'ElectricalDifferentTypeCvCodeValue'
            },
            /** Relation: Ethos Opportunity */
            EthosOpportunity : {
                RelationName: 'Ethos_Opportunity|permitRequest|OpportunityId',
                FieldPrefix: 'EthosOpportunity',
                PropertyName: 'EthosOpportunity'
            },
            /** Relation: Ethos Job Site */
            EthosJobSite : {
                RelationName: 'Ethos_JobSite|PermitRequest|JobSiteId',
                FieldPrefix: 'EthosJobSite',
                PropertyName: 'EthosJobSite'
            },
            /** Relation: Access Control */
            AccessControl : {
                RelationName: 'permitRequest|AccessControl|PermitRequestId',
                FieldPrefix: 'AccessControl',
                PropertyName: 'AccessControl'
            },
            /** Relation: Ethos Code Value - Cable Type */
            EthosCodeValueByCableTypeCv : {
                RelationName: 'Ethos_CodeValue|permitRequest|CableTypeCv',
                FieldPrefix: 'CableTypeCvEthosCodeValue',
                PropertyName: 'CableTypeCvEthosCodeValue'
            },
            /** Relation: Trust Code Value - Access Control Other Type */
            CodeValueByAccessControlOtherTypeCv : {
                RelationName: 'CodeValue|permitRequest|AccessControlOtherTypeCv',
                FieldPrefix: 'AccessControlOtherTypeCvCodeValue',
                PropertyName: 'AccessControlOtherTypeCvCodeValue'
            },
            /** Relation: Trust Code Value - Cable Type */
            CodeValueByVoiceDataCableTypeCV : {
                RelationName: 'CodeValue|permitRequest|VoiceDataCableTypeCV',
                FieldPrefix: 'VoiceDataCableTypeCVCodeValue',
                PropertyName: 'VoiceDataCableTypeCVCodeValue'
            },
            /** Relation: Ethos Code Value - Permit Team */
            EthosCodeValueByPermitTeamCv : {
                RelationName: 'Ethos_CodeValue|permitRequest|PermitTeamCv',
                FieldPrefix: 'PermitTeamCvEthosCodeValue',
                PropertyName: 'PermitTeamCvEthosCodeValue'
            },
            /** Relation: Ro Permit Request Last Note */
            RoPermitRequestLastNote : {
                RelationName: 'roPermitRequestLastNote|PermitRequest|PermitRequestId',
                FieldPrefix: 'RoPermitRequestLastNote',
                PropertyName: 'RoPermitRequestLastNote'
            },
            /** Relation: Trust Code Value - Demo or Install */
            CodeValueByFireAlarmDemoInstallCv : {
                RelationName: 'CodeValue|permitRequest|FireAlarmDemoInstallCv',
                FieldPrefix: 'FireAlarmDemoInstallCvCodeValue',
                PropertyName: 'FireAlarmDemoInstallCvCodeValue'
            },
            /** Relation: Trust Code Value - Cable Type */
            CodeValueByCCTVCableTypeCV : {
                RelationName: 'CodeValue|permitRequest|CCTVCableTypeCV',
                FieldPrefix: 'CCTVCableTypeCVCodeValue',
                PropertyName: 'CCTVCableTypeCVCodeValue'
            },
            /** Relation: Trust Code Value - Cable Type */
            CodeValueByAudioCableTypeCV : {
                RelationName: 'CodeValue|permitRequest|AudioCableTypeCV',
                FieldPrefix: 'AudioCableTypeCVCodeValue',
                PropertyName: 'AudioCableTypeCVCodeValue'
            },
            /** Relation: Trust Code Value - Access Control Type */
            CodeValueByAccessControlCV : {
                RelationName: 'CodeValue|permitRequest|AccessControlCV',
                FieldPrefix: 'AccessControlCVCodeValue',
                PropertyName: 'AccessControlCVCodeValue'
            },
            /** Relation: Ethos User - Requested By */
            EthosUserByRequestedByUserId : {
                RelationName: 'Ethos_User|permitRequest|RequestedByUserId',
                FieldPrefix: 'RequestedByEthosUser',
                PropertyName: 'RequestedByEthosUser'
            },
    };
}

class PermitRequestPermit implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'PermitRequestPermit.';

    constructor() {
        this.ItemDetail.ItemId=2699;
        this.ItemDetail.ItemName='PermitRequestPermit';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PermitRequestId : string = this.i + 'PermitRequestId';
    PermitId : string = this.i + 'PermitId';
    PermitTypeCV : string = this.i + 'PermitTypeCV';
    PermitRequestPermitId : string = this.i + 'PermitRequestPermitId';

    Relations = {
            /** Relation: Permit Request */
            PermitRequest : {
                RelationName: 'permitRequest|PermitRequestPermit|PermitRequestId',
                FieldPrefix: 'PermitRequest',
                PropertyName: 'PermitRequest'
            },
            /** Relation: Ethos Code Value - Permit Type */
            EthosCodeValueByPermitTypeCV : {
                RelationName: 'Ethos_CodeValue|PermitRequestPermit|PermitTypeCV',
                FieldPrefix: 'PermitTypeCVEthosCodeValue',
                PropertyName: 'PermitTypeCVEthosCodeValue'
            },
            /** Relation: Permit */
            Permit : {
                RelationName: 'Permit|PermitRequests|PermitId',
                FieldPrefix: 'Permit',
                PropertyName: 'Permit'
            },
    };
}

class PermitRequestPermitType implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'PermitRequestPermitType.';

    constructor() {
        this.ItemDetail.ItemId=2747;
        this.ItemDetail.ItemName='PermitRequestPermitType';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PermitRequestPermitTypeId : string = this.i + 'PermitRequestPermitTypeId';
    PermitRequestId : string = this.i + 'PermitRequestId';
    PermitTypeCv : string = this.i + 'PermitTypeCv';

    Relations = {
            /** Relation: Trust Code Value - Permit Type */
            CodeValueByPermitTypeCv : {
                RelationName: 'CodeValue|PermitRequestPermitType|PermitTypeCv',
                FieldPrefix: 'PermitTypeCvCodeValue',
                PropertyName: 'PermitTypeCvCodeValue'
            },
            /** Relation: Permit Request */
            PermitRequest : {
                RelationName: 'permitRequest|PermitRequestPermitType|PermitRequestId',
                FieldPrefix: 'PermitRequest',
                PropertyName: 'PermitRequest'
            },
            /** Relation: Ethos Code Value - Permit Type */
            EthosCodeValueByPermitTypeCv : {
                RelationName: 'Ethos_CodeValue|PermitRequestPermitType|PermitTypeCv',
                FieldPrefix: 'PermitTypeCvEthosCodeValue',
                PropertyName: 'PermitTypeCvEthosCodeValue'
            },
    };
}

class PermitStatus implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'PermitStatus.';

    constructor() {
        this.ItemDetail.ItemId=2744;
        this.ItemDetail.ItemName='PermitStatus';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PermitStatusId : string = this.i + 'PermitStatusId';
    PermitStatusDisplay : string = this.i + 'PermitStatusDisplay';
    PermitSsatusMeaning : string = this.i + 'PermitSsatusMeaning';
    PermitStatusOrder : string = this.i + 'PermitStatusOrder';
    IsActive : string = this.i + 'IsActive';
    PermitStatusShortName : string = this.i + 'PermitStatusShortName';

    Relations = {
    };
}

class RequiredCable implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'RequiredCable.';

    constructor() {
        this.ItemDetail.ItemId=2750;
        this.ItemDetail.ItemName='RequiredCable';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    RequiredCableId : string = this.i + 'RequiredCableId';
    CableTypeCv : string = this.i + 'CableTypeCv';
    Quantity : string = this.i + 'Quantity';
    Description : string = this.i + 'Description';
    PermitRequestId : string = this.i + 'PermitRequestId';
    PermitId : string = this.i + 'PermitId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    PermitTypeCv : string = this.i + 'PermitTypeCv';

    Relations = {
            /** Relation: Ethos Code Value - Permit Type */
            EthosCodeValueByPermitTypeCv : {
                RelationName: 'Ethos_CodeValue|RequiredCable|PermitTypeCv',
                FieldPrefix: 'PermitTypeCvEthosCodeValue',
                PropertyName: 'PermitTypeCvEthosCodeValue'
            },
            /** Relation: Permit */
            Permit : {
                RelationName: 'Permit|RequiredCable|PermitId',
                FieldPrefix: 'Permit',
                PropertyName: 'Permit'
            },
            /** Relation: Ethos User - Created By Ethos User */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|RequiredCable|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|RequiredCable|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Permit Request */
            PermitRequest : {
                RelationName: 'permitRequest|RequiredCable|PermitRequestId',
                FieldPrefix: 'PermitRequest',
                PropertyName: 'PermitRequest'
            },
    };
}

class RoEthosUser implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roEthos_User.';

    constructor() {
        this.ItemDetail.ItemId=2419;
        this.ItemDetail.ItemName='roEthos_User';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    UserName : string = this.i + 'UserName';
    FirstName : string = this.i + 'FirstName';
    LastName : string = this.i + 'LastName';
    MiddleName : string = this.i + 'MiddleName';
    PreferredName : string = this.i + 'PreferredName';
    Suffix : string = this.i + 'Suffix';
    OfficePhone : string = this.i + 'OfficePhone';
    MobilePhone : string = this.i + 'MobilePhone';
    WachterJobTitleId : string = this.i + 'WachterJobTitleId';
    WachterJobTitle : string = this.i + 'WachterJobTitle';
    UserTypeCv : string = this.i + 'UserTypeCv';
    UserTypeDisplay : string = this.i + 'UserTypeDisplay';
    StaffingAgencyId : string = this.i + 'StaffingAgencyId';
    ResourceGroupCv : string = this.i + 'ResourceGroupCv';
    ResourceGroup : string = this.i + 'ResourceGroup';
    EmployeeGroupId : string = this.i + 'EmployeeGroupId';
    EmployeeGroupCode : string = this.i + 'EmployeeGroupCode';
    EmployeeGroupDescription : string = this.i + 'EmployeeGroupDescription';
    EmpHireDate : string = this.i + 'empHireDate';
    AddressLongitude : string = this.i + 'AddressLongitude';
    AddressLatitude : string = this.i + 'AddressLatitude';
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    BirthMonth : string = this.i + 'BirthMonth';
    BirthDate : string = this.i + 'BirthDate';
    Email : string = this.i + 'Email';
    SupervisorUserId : string = this.i + 'SupervisorUserId';
    UserStatusWs : string = this.i + 'UserStatusWs';
    UserStatusMeaning : string = this.i + 'UserStatusMeaning';
    IsTerminated : string = this.i + 'IsTerminated';
    PictureAttachmentFileExtension : string = this.i + 'PictureAttachmentFileExtension';
    PictureAttachmentDisplay : string = this.i + 'PictureAttachmentDisplay';
    PictureAttachmentField : string = this.i + 'PictureAttachmentField';
    AdjustedStartDate : string = this.i + 'AdjustedStartDate';
    OfficeId : string = this.i + 'OfficeId';
    OfficeName : string = this.i + 'OfficeName';
    StreetAddress1 : string = this.i + 'StreetAddress1';
    StreetAddress2 : string = this.i + 'StreetAddress2';
    City : string = this.i + 'City';
    StateProvinceShortName : string = this.i + 'StateProvinceShortName';
    PostalCode : string = this.i + 'PostalCode';
    HasVehicle : string = this.i + 'HasVehicle';
    ShowUserOnMap : string = this.i + 'ShowUserOnMap';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';
    TeamName : string = this.i + 'TeamName';
    TeamShortName : string = this.i + 'TeamShortName';
    TeamNickName : string = this.i + 'TeamNickName';
    DepartmentName : string = this.i + 'DepartmentName';
    DepartmentShortName : string = this.i + 'DepartmentShortName';
    WachterDivisionId : string = this.i + 'WachterDivisionId';
    DivisionName : string = this.i + 'DivisionName';
    DivisionShortName : string = this.i + 'DivisionShortName';
    NameLastFirst : string = this.i + 'NameLastFirst';
    NameLastPrefered : string = this.i + 'NameLastPrefered';
    NameLastFirstPrefered : string = this.i + 'NameLastFirstPrefered';
    NameFirstLast : string = this.i + 'NameFirstLast';
    NamePreferedLast : string = this.i + 'NamePreferedLast';
    NameFirstPreferedLast : string = this.i + 'NameFirstPreferedLast';
    NameFirstMiddleLast : string = this.i + 'NameFirstMiddleLast';
    NamePreferedMidInitialLast : string = this.i + 'NamePreferedMidInitialLast';
    NameLastFirstPreferedStatus : string = this.i + 'NameLastFirstPreferedStatus';
    EmployeeType : string = this.i + 'EmployeeType';
    StateProvinceId : string = this.i + 'StateProvinceId';
    PictureAttachmentFileKey : string = this.i + 'PictureAttachmentFileKey';
    NameLastFirstPreferedType : string = this.i + 'NameLastFirstPreferedType';
    IsActive : string = this.i + 'IsActive';
    SpecialInstructions : string = this.i + 'SpecialInstructions';
    BirthMonthDate : string = this.i + 'BirthMonthDate';
    TerritoryId : string = this.i + 'TerritoryId';
    TerritoryName : string = this.i + 'TerritoryName';
    Company : string = this.i + 'Company';
    LicenseCount : string = this.i + 'LicenseCount';
    AXId : string = this.i + 'AXId';
    YrsService : string = this.i + 'YrsService';
    StaffingAgencyName : string = this.i + 'StaffingAgencyName';

    Relations = {
            /** Relation: Ethos Workflow Status - User Status */
            EthosWorkflowStatusByUserStatusWs : {
                RelationName: 'Ethos_WorkflowStatus|roEthos_User|UserStatusWs',
                FieldPrefix: 'UserStatusWsEthosWorkflowStatus',
                PropertyName: 'UserStatusWsEthosWorkflowStatus'
            },
            /** Relation: Ethos User */
            EthosUser : {
                RelationName: 'Ethos_User|roEthos_User|UserId',
                FieldPrefix: 'EthosUser',
                PropertyName: 'EthosUser'
            },
            /** Relation: Ro Ethos User - Supervisor User - One */
            RoEthosUserBySupervisorUserId : {
                RelationName: 'roEthos_User|roEthos_User|SupervisorId',
                FieldPrefix: 'SupervisorRoEthosUser',
                PropertyName: 'SupervisorRoEthosUser'
            },
    };
}

class RoEthosUserOriginal implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roEthos_UserOriginal.';

    constructor() {
        this.ItemDetail.ItemId=2661;
        this.ItemDetail.ItemName='roEthos_UserOriginal';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    AXId : string = this.i + 'AXId';
    UserName : string = this.i + 'UserName';
    FirstName : string = this.i + 'FirstName';
    LastName : string = this.i + 'LastName';
    MiddleName : string = this.i + 'MiddleName';
    PreferredName : string = this.i + 'PreferredName';
    Suffix : string = this.i + 'Suffix';
    OfficePhone : string = this.i + 'OfficePhone';
    MobilePhone : string = this.i + 'MobilePhone';
    WachterJobTitleId : string = this.i + 'WachterJobTitleId';
    WachterJobTitle : string = this.i + 'WachterJobTitle';
    UserTypeCv : string = this.i + 'UserTypeCv';
    UserTypeDisplay : string = this.i + 'UserTypeDisplay';
    EmployeeType : string = this.i + 'EmployeeType';
    StaffingAgencyId : string = this.i + 'StaffingAgencyId';
    ResourceGroupCv : string = this.i + 'ResourceGroupCv';
    ResourceGroup : string = this.i + 'ResourceGroup';
    EmployeeGroupId : string = this.i + 'EmployeeGroupId';
    EmployeeGroupCode : string = this.i + 'EmployeeGroupCode';
    EmployeeGroupDescription : string = this.i + 'EmployeeGroupDescription';
    EmpHireDate : string = this.i + 'empHireDate';
    AddressLongitude : string = this.i + 'AddressLongitude';
    AddressLatitude : string = this.i + 'AddressLatitude';
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    BirthMonth : string = this.i + 'BirthMonth';
    BirthDate : string = this.i + 'BirthDate';
    BirthMonthDate : string = this.i + 'BirthMonthDate';
    Email : string = this.i + 'Email';
    SupervisorUserId : string = this.i + 'SupervisorUserId';
    UserStatusWs : string = this.i + 'UserStatusWs';
    UserStatusMeaning : string = this.i + 'UserStatusMeaning';
    IsActive : string = this.i + 'IsActive';
    IsTerminated : string = this.i + 'IsTerminated';
    PictureAttachmentFileExtension : string = this.i + 'PictureAttachmentFileExtension';
    PictureAttachmentDisplay : string = this.i + 'PictureAttachmentDisplay';
    PictureAttachmentFileKey : string = this.i + 'PictureAttachmentFileKey';
    PictureAttachmentField : string = this.i + 'PictureAttachmentField';
    AdjustedStartDate : string = this.i + 'AdjustedStartDate';
    OfficeId : string = this.i + 'OfficeId';
    OfficeName : string = this.i + 'OfficeName';
    StreetAddress1 : string = this.i + 'StreetAddress1';
    StreetAddress2 : string = this.i + 'StreetAddress2';
    City : string = this.i + 'City';
    StateProvinceId : string = this.i + 'StateProvinceId';
    StateProvinceShortName : string = this.i + 'StateProvinceShortName';
    TerritoryId : string = this.i + 'TerritoryId';
    TerritoryName : string = this.i + 'TerritoryName';
    PostalCode : string = this.i + 'PostalCode';
    HasVehicle : string = this.i + 'HasVehicle';
    ShowUserOnMap : string = this.i + 'ShowUserOnMap';
    SpecialInstructions : string = this.i + 'SpecialInstructions';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';
    TeamName : string = this.i + 'TeamName';
    TeamShortName : string = this.i + 'TeamShortName';
    TeamNickName : string = this.i + 'TeamNickName';
    DepartmentName : string = this.i + 'DepartmentName';
    DepartmentShortName : string = this.i + 'DepartmentShortName';
    WachterDivisionId : string = this.i + 'WachterDivisionId';
    DivisionName : string = this.i + 'DivisionName';
    DivisionShortName : string = this.i + 'DivisionShortName';
    Company : string = this.i + 'Company';
    LicenseCount : string = this.i + 'LicenseCount';
    NameLastFirst : string = this.i + 'NameLastFirst';
    NameLastPrefered : string = this.i + 'NameLastPrefered';
    NameLastFirstPrefered : string = this.i + 'NameLastFirstPrefered';
    NameFirstLast : string = this.i + 'NameFirstLast';
    NamePreferedLast : string = this.i + 'NamePreferedLast';
    NameFirstPreferedLast : string = this.i + 'NameFirstPreferedLast';
    NameFirstMiddleLast : string = this.i + 'NameFirstMiddleLast';
    NamePreferedMidInitialLast : string = this.i + 'NamePreferedMidInitialLast';
    NameLastFirstPreferedStatus : string = this.i + 'NameLastFirstPreferedStatus';
    NameLastFirstPreferedType : string = this.i + 'NameLastFirstPreferedType';

    Relations = {
    };
}

class RoInspections implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roInspections.';

    constructor() {
        this.ItemDetail.ItemId=2749;
        this.ItemDetail.ItemName='roInspections';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    TechMobile : string = this.i + 'TechMobile';
    TechOffice : string = this.i + 'TechOffice';
    TechEmail : string = this.i + 'TechEmail';
    InspectionId : string = this.i + 'InspectionId';
    InspectionType : string = this.i + 'InspectionType';
    TechnicianOnSite : string = this.i + 'TechnicianOnSite';
    TechnicianUserId : string = this.i + 'TechnicianUserId';
    AvailableDates : string = this.i + 'AvailableDates';
    PreferredTimeOfDayCv : string = this.i + 'PreferredTimeOfDayCv';
    AdditionalNotes : string = this.i + 'AdditionalNotes';
    PermitId : string = this.i + 'PermitId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    InspectionNotes : string = this.i + 'InspectionNotes';
    ScheduledDateTime : string = this.i + 'ScheduledDateTime';
    ScheduledNotes : string = this.i + 'ScheduledNotes';
    ResultCv : string = this.i + 'ResultCv';
    ResultDateTime : string = this.i + 'ResultDateTime';
    ResultNotes : string = this.i + 'ResultNotes';
    AdditionalInspectionNeeded : string = this.i + 'AdditionalInspectionNeeded';
    PreferredTimeOfDay : string = this.i + 'PreferredTimeOfDay';
    Result : string = this.i + 'Result';
    TechFirstName : string = this.i + 'TechFirstName';
    TechLastName : string = this.i + 'TechLastName';

    Relations = {
            /** Relation: Permit */
            Permit : {
                RelationName: 'roInspections|Permit|PermitId',
                FieldPrefix: 'Permit',
                PropertyName: 'Permit'
            },
    };
}

class RoPermitRequestLastNote implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roPermitRequestLastNote.';

    constructor() {
        this.ItemDetail.ItemId=2745;
        this.ItemDetail.ItemName='roPermitRequestLastNote';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PermitRequestId : string = this.i + 'PermitRequestId';
    Note : string = this.i + 'Note';
    NoteId : string = this.i + 'NoteId';

    Relations = {
            /** Relation: Permit Request */
            PermitRequest : {
                RelationName: 'roPermitRequestLastNote|PermitRequest|PermitRequestId',
                FieldPrefix: 'PermitRequest',
                PropertyName: 'PermitRequest'
            },
    };
}

class RoPermitRequests implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roPermitRequests.';

    constructor() {
        this.ItemDetail.ItemId=2701;
        this.ItemDetail.ItemName='roPermitRequests';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PermitRequestId : string = this.i + 'PermitRequestId';
    RequestedByUserId : string = this.i + 'RequestedByUserId';
    JobId : string = this.i + 'JobId';
    OpportunityId : string = this.i + 'OpportunityId';
    JobNumberId : string = this.i + 'JobNumberId';
    StreetAddress1 : string = this.i + 'StreetAddress1';
    StreetAddress2 : string = this.i + 'StreetAddress2';
    City : string = this.i + 'City';
    CountyId : string = this.i + 'CountyId';
    StateProvinceId : string = this.i + 'StateProvinceId';
    CountyName : string = this.i + 'CountyName';
    StateProvinceName : string = this.i + 'StateProvinceName';
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    WachterDivisionId : string = this.i + 'WachterDivisionId';

    Relations = {
            /** Relation: Permit Request */
            PermitRequest : {
                RelationName: 'roPermitRequests|permitRequest|PermitRequestId',
                FieldPrefix: 'PermitRequest',
                PropertyName: 'PermitRequest'
            },
    };
}

class RoPermits implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roPermits.';

    constructor() {
        this.ItemDetail.ItemId=2700;
        this.ItemDetail.ItemName='roPermits';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PermitId : string = this.i + 'PermitId';
    RequestedByUser : string = this.i + 'RequestedByUser';
    PermitStatusWs : string = this.i + 'PermitStatusWs';
    DueDate : string = this.i + 'DueDate';
    JobId : string = this.i + 'JobId';
    CanBePulledOnline : string = this.i + 'CanBePulledOnline';
    InspectionRequestDate : string = this.i + 'InspectionRequestDate';
    InspectionCompleteDate : string = this.i + 'InspectionCompleteDate';
    WachterPermitNumber : string = this.i + 'WachterPermitNumber';
    PermitCost : string = this.i + 'PermitCost';
    PerformingWorkCv : string = this.i + 'PerformingWorkCv';
    SubcontractorLicense : string = this.i + 'SubcontractorLicense';
    PermitTeamCv : string = this.i + 'PermitTeamCv';
    AssignedToUser : string = this.i + 'AssignedToUser';
    FloorCount : string = this.i + 'FloorCount';
    FacilitySquareFeet : string = this.i + 'FacilitySquareFeet';
    CableTypeCv : string = this.i + 'CableTypeCv';
    BuildingPermitNumber : string = this.i + 'BuildingPermitNumber';
    UndergroundCablingPresent : string = this.i + 'UndergroundCablingPresent';
    CablingInConduitPresent : string = this.i + 'CablingInConduitPresent';
    GCPresent : string = this.i + 'GCPresent';
    GCName : string = this.i + 'GCName';
    PropertyOwnerName : string = this.i + 'PropertyOwnerName';
    PropertyOwnerCity : string = this.i + 'PropertyOwnerCity';
    PropertyOwnerStateId : string = this.i + 'PropertyOwnerStateId';
    PropertyOwnerPostalCode : string = this.i + 'PropertyOwnerPostalCode';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    AttachmentId : string = this.i + 'AttachmentId';
    JobSiteId : string = this.i + 'JobSiteId';
    ScopeOfWork : string = this.i + 'ScopeOfWork';
    SharepointId : string = this.i + 'SharepointId';
    PropertyOwnerAddress : string = this.i + 'PropertyOwnerAddress';
    PermitTypeCv : string = this.i + 'PermitTypeCv';
    NoteParentId : string = this.i + 'NoteParentId';
    JobNumberId : string = this.i + 'JobNumberId';
    OpportunityId : string = this.i + 'OpportunityId';
    OverallContractValuation : string = this.i + 'OverallContractValuation';
    StreetAddress1 : string = this.i + 'StreetAddress1';
    StreetAddress2 : string = this.i + 'StreetAddress2';
    City : string = this.i + 'City';
    StateProvinceId : string = this.i + 'StateProvinceId';
    SiteTypeCv : string = this.i + 'SiteTypeCv';
    JobNumberName : string = this.i + 'JobNumberName';
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    WachterDivisionId : string = this.i + 'WachterDivisionId';
    CountyId : string = this.i + 'CountyId';
    CountyName : string = this.i + 'CountyName';
    InspectionStateCv : string = this.i + 'InspectionStateCv';

    Relations = {
            /** Relation: Permit */
            Permit : {
                RelationName: 'roPermit}Permit|PermitId',
                FieldPrefix: 'Permit',
                PropertyName: 'Permit'
            },
    };
}


export class PermitsMetaData {

    static AccessControl : AccessControl = new AccessControl();
    static CodeValue : CodeValue = new CodeValue();
    static EthosCodeValue : EthosCodeValue = new EthosCodeValue();
    static EthosCodeValueCustom : EthosCodeValueCustom = new EthosCodeValueCustom();
    static EthosJob : EthosJob = new EthosJob();
    static EthosJobNumber : EthosJobNumber = new EthosJobNumber();
    static EthosJobNumberForecast : EthosJobNumberForecast = new EthosJobNumberForecast();
    static EthosJobNumberPhase : EthosJobNumberPhase = new EthosJobNumberPhase();
    static EthosJobSite : EthosJobSite = new EthosJobSite();
    static EthosJobSow : EthosJobSow = new EthosJobSow();
    static EthosOpportunity : EthosOpportunity = new EthosOpportunity();
    static EthosUser : EthosUser = new EthosUser();
    static EthosUserDiff : EthosUserDiff = new EthosUserDiff();
    static EthosUserSkill : EthosUserSkill = new EthosUserSkill();
    static EthosWachterDepartment : EthosWachterDepartment = new EthosWachterDepartment();
    static EthosWachterTeam : EthosWachterTeam = new EthosWachterTeam();
    static EthosWorkflowStatus : EthosWorkflowStatus = new EthosWorkflowStatus();
    static EthosWorkflowStatusSet : EthosWorkflowStatusSet = new EthosWorkflowStatusSet();
    static Inspection : Inspection = new Inspection();
    static NoteType : NoteType = new NoteType();
    static Permit : Permit = new Permit();
    static PermitPermitType : PermitPermitType = new PermitPermitType();
    static PermitRequest : PermitRequest = new PermitRequest();
    static PermitRequestPermit : PermitRequestPermit = new PermitRequestPermit();
    static PermitRequestPermitType : PermitRequestPermitType = new PermitRequestPermitType();
    static PermitStatus : PermitStatus = new PermitStatus();
    static RequiredCable : RequiredCable = new RequiredCable();
    static RoEthosUser : RoEthosUser = new RoEthosUser();
    static RoEthosUserOriginal : RoEthosUserOriginal = new RoEthosUserOriginal();
    static RoInspections : RoInspections = new RoInspections();
    static RoPermitRequestLastNote : RoPermitRequestLastNote = new RoPermitRequestLastNote();
    static RoPermitRequests : RoPermitRequests = new RoPermitRequests();
    static RoPermits : RoPermits = new RoPermits();
}

// Generated Entity Interfaces
export interface AccessControlEntity extends DwOrmData {
    // Attributes
    AccessControlId?: number;
    AccessControlCv?: number;
    Quantity?: number;
    Description?: string;
    PermitRequestId?: number;
    PermitId?: number;
    CreatedByDateTime?: string;
    CreatedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    ModifiedByEthos_UserId?: number;

    // Display Attributes
    AccessControlCvDisplay?: string;
    PermitRequestIdDisplay?: string;
    PermitIdDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;
    // Relations
    Permit? : PermitEntity;
    AccessControlCvCodeValue? : CodeValueEntity;
    CreatedByEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    PermitRequest? : PermitRequestEntity;
}

export interface CodeValueEntity extends DwOrmData {
    // Attributes
    CodeValueId?: number;
    CodeSetId?: number;
    Display?: string;
    Meaning?: string;
    Description?: string;
    CodeValueOrder?: number;
    IsActive?: boolean;

    // Display Attributes
    CodeSetIdDisplay?: string;
    // Relations
    FireAlarmDemoInstallCvPermit? : PermitEntity[];
    CCTVCableTypeCVPermitRequest? : PermitRequestEntity[];
    CableTypeCvPermit? : PermitEntity[];
    CCTVInstallTypeCvPermitRequest? : PermitRequestEntity[];
    ElectricalOutletTypeCvPermitRequest? : PermitRequestEntity[];
    FireAlarmDemoInstallCvPermitRequest? : PermitRequestEntity[];
    ResultCvInspection? : InspectionEntity[];
    ElectricalDifferentTypeCvPermitRequest? : PermitRequestEntity[];
    VoiceDataCableTypeCVPermitRequest? : PermitRequestEntity[];
    AccessControlCvAccessControl? : AccessControlEntity[];
    StatusCvPermitRequest? : PermitRequestEntity[];
    PermitRequestTypeCvPermitRequest? : PermitRequestEntity[];
    CCTVInstallTypeCvPermit? : PermitEntity[];
    PermitTypeCvPermitPermitType? : PermitPermitTypeEntity[];
    ElectricalWorkTypeCvPermit? : PermitEntity[];
    AudioCableTypeCVPermitRequest? : PermitRequestEntity[];
    AccessControlTypeCvPermit? : PermitEntity[];
    PreferredTimeOfDayCvInspection? : InspectionEntity[];
    ElectricalOutletTypeCvPermit? : PermitEntity[];
    InspectionStateCvPermit? : PermitEntity[];
    AccessControlCVPermitRequest? : PermitRequestEntity[];
    PermitTypeCvPermitRequestPermitType? : PermitRequestPermitTypeEntity[];
    ElectricalDifferentTypeCvPermit? : PermitEntity[];
    ElectricalWorkTypeCvPermitRequest? : PermitRequestEntity[];
    AccessControlOtherTypeCvPermitRequest? : PermitRequestEntity[];
}

export interface EthosCodeValueEntity extends DwOrmData {
    // Attributes
    CodeValueId?: number;
    CodeSetId?: number;
    Display?: string;
    Meaning?: string;
    Description?: string;
    CodeValueOrder?: number;
    IsActive?: boolean;
    ImagePath?: string;

    // Relations
    PermitTypeCVPermitRequestPermit? : PermitRequestPermitEntity[];
    CableTypeCvPermitRequest? : PermitRequestEntity[];
    PermitTypeCvPermitRequest? : PermitRequestEntity[];
    CableTypeCvPermit? : PermitEntity[];
    PermitTypeCvRequiredCable? : RequiredCableEntity[];
    PlenumOrRiserCvPermit? : PermitEntity[];
    PermitTeamCvPermitRequest? : PermitRequestEntity[];
    UserTypeCvEthosUser? : EthosUserEntity[];
    PlenumRiserPermitRequest? : PermitRequestEntity[];
    PermitTypeCvPermit? : PermitEntity[];
    PerformingWorkCvPermit? : PermitEntity[];
    PermitTeamCvPermit? : PermitEntity[];
    PermitTypeCvPermitPermitType? : PermitPermitTypeEntity[];
    PermitTypeCvPermitRequestPermitType? : PermitRequestPermitTypeEntity[];
}

export interface EthosCodeValueCustomEntity extends DwOrmData {
    // Attributes
    CodeValueCustomId?: number;
    CodeSetId?: number;
    Display?: string;
    Meaning?: string;
    Description?: string;
    CodeValueOrder?: number;
    IsActive?: boolean;

    // Relations
}

export interface EthosJobEntity extends DwOrmData {
    // Attributes
    JobId?: number;
    JobNumberId?: number;
    JobEtcDateTime?: string;

    // Display Attributes
    JobIdDisplay?: string;
    JobNumberIdDisplay?: string;
    // Relations
    PermitRequest? : PermitRequestEntity[];
    Permit? : PermitEntity[];
    // Duplicate property excluded
    // PermitRequest : PermitRequestEntity[];
    EthosJobSite? : EthosJobSiteEntity[];
    EthosJobSow? : EthosJobSowEntity[];
    EthosJobSiteJobId? : EthosJobSiteEntity;
    // Duplicate property excluded
    // PermitRequest : PermitRequestEntity[];
    EthosJobNumberJobNumberId? : EthosJobNumberEntity[];
    // Duplicate property excluded
    // PermitRequest : PermitRequestEntity[];
    WJIDPermitRequest? : PermitRequestEntity[];
    EthosJobNumber? : EthosJobNumberEntity;
}

export interface EthosJobNumberEntity extends DwOrmData {
    // Attributes
    JobNumberId?: number;
    JobNumberStatusWs?: number;
    JobNumberStatus?: string;
    JobNumber?: string;
    CustomerId?: number;
    JobName?: string;
    EstimatedStartDate?: string;
    EstimatedEndDate?: string;
    ProjectMgr1UserId?: number;
    ProjectMgr2UserId?: number;
    AsstProjectMgrUserId?: number;
    SeniorMgrUserId?: number;
    LeadTech1UserId?: number;
    LeadTech2UserId?: number;
    InvoiceApproval1UserId?: number;
    InvoiceApproval2UserId?: number;
    ForecastStatusCv?: number;
    ForecastStatus?: string;
    WachterTeamId?: number;
    CustomerName?: string;
    CustomerShortName?: string;
    BillingInstructions?: string;
    ChangeOrderProcessInstructions?: string;
    PartialBilling?: boolean;
    FinalInvoiceDate?: string;
    InvoiceDeliveryTypeData?: string;
    InvoiceDeliveryTypeCV?: number;
    OpportunityId?: number;
    EndCustomerId?: number;

    // Display Attributes
    JobNumberIdDisplay?: string;
    JobNumberStatusWsDisplay?: string;
    CustomerIdDisplay?: string;
    ProjectMgr1UserIdDisplay?: string;
    ProjectMgr2UserIdDisplay?: string;
    AsstProjectMgrUserIdDisplay?: string;
    SeniorMgrUserIdDisplay?: string;
    LeadTech1UserIdDisplay?: string;
    LeadTech2UserIdDisplay?: string;
    InvoiceApproval1UserIdDisplay?: string;
    InvoiceApproval2UserIdDisplay?: string;
    WachterTeamIdDisplay?: string;
    InvoiceDeliveryTypeCVDisplay?: string;
    OpportunityIdDisplay?: string;
    EndCustomerIdDisplay?: string;
    // Relations
    UserIdEthosUser? : EthosUserEntity[];
    EthosJob? : EthosJobEntity[];
    EthosOpportunity? : EthosOpportunityEntity;
    // Duplicate property excluded
    // EthosOpportunity : EthosOpportunityEntity;
    EthosWachterTeam? : EthosWachterTeamEntity;
    EthosJobJobNumberId? : EthosJobEntity;
    JobNumberStatusWsEthosWorkflowStatus? : EthosWorkflowStatusEntity;
    // Duplicate property excluded
    // EthosOpportunity : EthosOpportunityEntity;
    // Duplicate property excluded
    // EthosOpportunity : EthosOpportunityEntity;
}

export interface EthosJobNumberForecastEntity extends DwOrmData {
    // Attributes
    JobNumberForecastId?: number;
    JobNumberId?: number;
    YeProjectedCosts?: number;
    YeProjectedRevenue?: number;
    IsDeleted?: boolean;
    CreatedBy?: number;
    ModifiedBy?: number;
    CreatedDateTime?: string;
    ModifiedDateTime?: string;
    Notes?: string;
    NoteAgingOverSixtyDays?: string;
    NoteOverUnderBilling?: string;
    NoteLowForecastedGpm?: string;
    NoteChangedGpm?: string;
    AXIntegrationID?: string;
    TotalForecastRevenue?: number;
    TotalForecastCost?: number;

    // Relations
}

export interface EthosJobNumberPhaseEntity extends DwOrmData {
    // Attributes
    JobNumberPhaseId?: number;
    JobNumberId?: number;
    PhaseCode?: string;
    PhaseDescription?: string;
    IsActive?: boolean;
    IsVisible?: boolean;
    IsOnSite?: boolean;
    IsEstimate?: boolean;
    JobNumberPhaseStatusWs?: number;
    WorkflowStatusDisplay?: string;

    // Relations
    JobNumberPhaseStatusWsEthosWorkflowStatus? : EthosWorkflowStatusEntity;
}

export interface EthosJobSiteEntity extends DwOrmData {
    // Attributes
    JobSiteId?: number;
    JobId?: number;
    SiteId?: number;
    IsDeleted?: boolean;
    LookUpKey?: string;
    SubJobNumber?: string;
    FullJobNumber?: string;

    // Display Attributes
    JobIdDisplay?: string;
    SiteIdDisplay?: string;
    // Relations
    PermitRequest? : PermitRequestEntity[];
    EthosJobSow? : EthosJobSowEntity[];
    Permit? : PermitEntity[];
    EthosJobJobId? : EthosJobEntity[];
    EthosJob? : EthosJobEntity;
}

export interface EthosJobSowEntity extends DwOrmData {
    // Attributes
    JobSowId?: number;
    SowId?: number;
    JobId?: number;
    JobSiteId?: number;

    // Display Attributes
    SowIdDisplay?: string;
    JobIdDisplay?: string;
    JobSiteIdDisplay?: string;
    // Relations
    EthosJobSite? : EthosJobSiteEntity;
    EthosJob? : EthosJobEntity;
}

export interface EthosOpportunityEntity extends DwOrmData {
    // Attributes
    OpportunityId?: number;
    OpportunityStatusWs?: number;
    OpportunityName?: string;
    CustomerId?: number;

    // Display Attributes
    CustomerIdDisplay?: string;
    // Relations
    EthosJobNumber? : EthosJobNumberEntity[];
    // Duplicate property excluded
    // EthosJobNumber : EthosJobNumberEntity[];
    OpportunityStatusWsEthosWorkflowStatus? : EthosWorkflowStatusEntity;
    PermitRequest? : PermitRequestEntity[];
    // Duplicate property excluded
    // EthosJobNumber : EthosJobNumberEntity[];
    // Duplicate property excluded
    // EthosJobNumber : EthosJobNumberEntity[];
}

export interface EthosUserEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    UserName?: string;
    FirstName?: string;
    LastName?: string;
    MiddleName?: string;
    PreferredName?: string;
    Suffix?: string;
    OfficePhone?: string;
    MobilePhone?: string;
    WachterJobTitleId?: number;
    WachterJobTitle?: string;
    UserTypeCv?: number;
    UserTypeDisplay?: string;
    StaffingAgencyId?: number;
    ResourceGroupCv?: number;
    ResourceGroup?: string;
    EmployeeGroupId?: number;
    EmployeeGroupCode?: string;
    EmployeeGroupDescription?: string;
    empHireDate?: string;
    AddressLongitude?: number;
    AddressLatitude?: number;
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    BirthMonth?: number;
    BirthDate?: number;
    Email?: string;
    SupervisorUserId?: number;
    UserStatusWs?: number;
    UserStatusMeaning?: string;
    IsTerminated?: boolean;
    PictureAttachmentFileExtension?: string;
    PictureAttachmentDisplay?: string;
    PictureAttachmentField?: number;
    AdjustedStartDate?: string;
    OfficeId?: number;
    OfficeName?: string;
    StreetAddress1?: string;
    StreetAddress2?: string;
    City?: string;
    StateProvinceShortName?: string;
    PostalCode?: string;
    HasVehicle?: boolean;
    ShowUserOnMap?: boolean;
    RowInsertDateTime?: string;
    EmployeeType?: string;
    StateProvinceId?: number;
    PictureAttachmentFileKey?: string;
    CustomerId?: number;
    SubcontractorId?: number;
    SpecialInstructions?: string;
    isVaxxed?: boolean;

    // Display Attributes
    UserTypeCvDisplay?: string;
    WachterTeamIdDisplay?: string;
    WachterDepartmentIdDisplay?: string;
    SupervisorUserIdDisplay?: string;
    // Relations
    ModifiedByEthosPermit? : PermitEntity[];
    RequestedByPermitRequest? : PermitRequestEntity[];
    UserTypeCvEthosCodeValue? : EthosCodeValueEntity;
    UserStatusWsEthosWorkflowStatus? : EthosWorkflowStatusEntity;
    SupervisorEthosUser? : EthosUserEntity[];
    ModifiedByEthosRequiredCable? : RequiredCableEntity[];
    EthosWachterDepartment? : EthosWachterDepartmentEntity[];
    CreatedByEthosRequiredCable? : RequiredCableEntity[];
    CreatedByEthosInspection? : InspectionEntity[];
    // Duplicate property excluded
    // SupervisorEthosUser : EthosUserEntity;
    // Duplicate property excluded
    // SupervisorEthosUser : EthosUserEntity;
    AssignedToUserPermit? : PermitEntity[];
    AssignedToPermitRequest? : PermitRequestEntity[];
    ModifiedByEthosAccessControl? : AccessControlEntity[];
    SecondaryAssignedToPermitRequest? : PermitRequestEntity[];
    CreatedByEthosAccessControl? : AccessControlEntity[];
    RoEthosUser? : RoEthosUserEntity;
    CreatedByEthosPermitRequest? : PermitRequestEntity[];
    CreatedByEthosPermit? : PermitEntity[];
    TechnicianInspection? : InspectionEntity[];
    RequestedByUserPermit? : PermitEntity[];
    UserIdEthosJobNumber? : EthosJobNumberEntity;
    ModifiedByEthosPermitRequest? : PermitRequestEntity[];
    // Duplicate property excluded
    // SupervisorEthosUser : EthosUserEntity[];
}

export interface EthosUserDiffEntity extends DwOrmData {
    // Attributes
    Ethos_UserDiffId?: number;
    Ethos_UserId?: number;
    FieldName?: string;
    OldValue?: string;
    NewValue?: string;
    ChangedDateTime?: string;

    // Relations
}

export interface EthosUserSkillEntity extends DwOrmData {
    // Attributes
    UserSkillId?: number;
    UserId?: number;
    SkillCv?: number;
    Dislay?: string;
    Meaning?: string;

    // Relations
}

export interface EthosWachterDepartmentEntity extends DwOrmData {
    // Attributes
    WachterDepartmentId?: number;
    DepartmentTypeCv?: number;
    DepartmentTypeMeaning?: string;
    WachterDivisionId?: number;
    DivisionName?: string;
    DivisionShortName?: string;
    DepartmentName?: string;
    DepartmentShortName?: string;
    DepartmentDirectorUserId?: number;
    IsDeleted?: boolean;
    DepartmentManagerUserId?: number;
    DepartmentAsstManagerUserId?: number;
    JobNumberId?: number;
    AxIntegrationId?: string;
    JobNumberPhaseId?: number;
    RowInsertDateTime?: string;

    // Display Attributes
    DepartmentDirectorUserIdDisplay?: string;
    DepartmentManagerUserIdDisplay?: string;
    DepartmentAsstManagerUserIdDisplay?: string;
    // Relations
    EthosWachterTeam? : EthosWachterTeamEntity[];
    EthosUser? : EthosUserEntity;
}

export interface EthosWachterTeamEntity extends DwOrmData {
    // Attributes
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    TeamTypeCv?: number;
    TeamTypeMeaning?: string;
    TeamName?: string;
    TeamLeaderUserId?: number;
    AxIntegrationId?: string;
    TeamShortName?: string;
    TeamNickName?: string;
    IsDeleted?: boolean;
    OverheadJobNumberId?: number;
    OverheadJobNumberPhaseId?: number;
    RowInsertDateTime?: string;

    // Display Attributes
    WachterDepartmentIdDisplay?: string;
    TeamLeaderUserIdDisplay?: string;
    // Relations
    EthosWachterDepartment? : EthosWachterDepartmentEntity;
    EthosJobNumber? : EthosJobNumberEntity[];
}

export interface EthosWorkflowStatusEntity extends DwOrmData {
    // Attributes
    WorkflowStatusId?: number;
    WorkflowStatusSetId?: number;
    WorkflowStatus?: string;
    WorkflowStatusMeaning?: string;
    WorkflowStatusOrder?: number;
    IsActive?: boolean;
    WorkflowStatusShortName?: string;

    // Display Attributes
    WorkflowStatusSetIdDisplay?: string;
    // Relations
    EthosWorkflowStatusSet? : EthosWorkflowStatusSetEntity;
    JobNumberStatusWsEthosJobNumber? : EthosJobNumberEntity[];
    OpportunityStatusWsEthosOpportunity? : EthosOpportunityEntity[];
    UserStatusWsEthosUser? : EthosUserEntity[];
    JobNumberPhaseStatusWsEthosJobNumberPhase? : EthosJobNumberPhaseEntity[];
    PermitStatusWsPermit? : PermitEntity[];
    UserStatusWsRoEthosUser? : RoEthosUserEntity[];
}

export interface EthosWorkflowStatusSetEntity extends DwOrmData {
    // Attributes
    WorkflowStatusSetId?: number;
    WorkflowStatusSetName?: string;
    MetaDataItemId?: number;
    MetaDataAttributeId?: number;
    RelatedCodeSetId?: number;
    UseTransitions?: boolean;
    IsActive?: boolean;

    // Relations
    EthosWorkflowStatus? : EthosWorkflowStatusEntity[];
}

export interface InspectionEntity extends DwOrmData {
    // Attributes
    InspectionId?: number;
    InspectionType?: string;
    TechnicianOnSite?: boolean;
    TechnicianUserId?: number;
    AvailableDates?: string;
    PreferredTimeOfDayCv?: number;
    AdditionalNotes?: string;
    PermitId?: number;
    CreatedByDateTime?: string;
    CreatedByEthos_UserId?: number;
    InspectionNotes?: string;
    ScheduledDateTime?: string;
    ScheduledNotes?: string;
    ResultCv?: number;
    ResultDateTime?: string;
    ResultNotes?: string;
    AdditionalInspectionNeeded?: boolean;

    // Display Attributes
    TechnicianUserIdDisplay?: string;
    PreferredTimeOfDayCvDisplay?: string;
    PermitIdDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;
    ResultCvDisplay?: string;
    // Relations
    TechnicianEthosUser? : EthosUserEntity;
    CreatedByEthosEthosUser? : EthosUserEntity;
    Permit? : PermitEntity;
    PreferredTimeOfDayCvCodeValue? : CodeValueEntity;
    ResultCvCodeValue? : CodeValueEntity;
}

export interface NoteTypeEntity extends DwOrmData {
    // Attributes
    NoteTypeId?: number;
    NoteType?: string;
    MetaDataLookupId?: number;

    // Relations
}

export interface PermitEntity extends DwOrmData {
    // Attributes
    PermitId?: number;
    RequestedByUser?: number;
    PermitTypeCv?: number;
    DueDate?: string;
    ScopeOfWork?: string;
    InspectionRequestDate?: string;
    InspectionCompleteDate?: string;
    WachterPermitNumber?: string;
    PermitCost?: number;
    PerformingWorkCv?: number;
    SubcontractorLicense?: string;
    AssignedToUser?: number;
    FloorCount?: number;
    FacilitySquareFeet?: number;
    BuildingPermitNumber?: string;
    UndergroundCablingPresent?: boolean;
    CablingInConduitPresent?: boolean;
    GCPresent?: boolean;
    GCName?: string;
    PropertyOwnerName?: string;
    CableTypeCv?: number;
    PermitStatusWs?: number;
    JobId?: number;
    PermitTeamCv?: number;
    CreatedByDateTime?: string;
    CreatedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    AttachmentId?: number;
    CanBePulledOnline?: boolean;
    PropertyOwnerCity?: string;
    PropertyOwnerStateId?: number;
    PropertyOwnerPostalCode?: string;
    JobSiteId?: number;
    SharepointId?: number;
    PropertyOwnerAddress?: string;
    NoteParentId?: number;
    PermitRequestid?: number;
    OverallContractValuation?: number;
    PlenumOrRiserCv?: number;
    CableQuantity?: number;
    HasCameras?: boolean;
    CameraQuantity?: number;
    HasSpeakers?: boolean;
    SpeakerQuantity?: number;
    InitiationDeviceQuantity?: number;
    NACQuantity?: number;
    SwappingOutPanel?: boolean;
    OutletQuantity?: number;
    HasCardReaders?: boolean;
    CardReaderQuantity?: number;
    HasPaging?: boolean;
    AlarmPanelInstallation?: boolean;
    DeviceType?: string;
    OverallSOWValuation?: number;
    TotalAmps?: number;
    ElectricalPanelQuantity?: number;
    CircuitQuantity?: number;
    AccessControlTypeCv?: number;
    AccessControlQuantity?: number;
    AlarmPanelQuantity?: string;
    FilesInSharepoint?: boolean;
    CriticalPower?: boolean;
    RoomCount?: number;
    IsNewFireSystem?: boolean;
    CableTypeOtherName?: string;
    ElectricalOutletTypeCv?: number;
    ElectricalOtherOutletType?: string;
    IsLicensedTechnician?: boolean;
    TechnicianNameAndLicenseNumber?: string;
    ElectricalOtherWorkType?: string;
    ElectricalTotalVoltage?: number;
    IsTyingIntoFireAlarm?: boolean;
    AccessControlOther?: string;
    FireAlarmDemoInstallCv?: number;
    FireAlarmInstallRadio?: boolean;
    DataVoiceUsingExisting?: boolean;
    DataVoiceReplacingCable?: boolean;
    DataVoiceNewCable?: boolean;
    CCTVUsingExisting?: boolean;
    CCTVReplacingCable?: boolean;
    CCTVNewCable?: boolean;
    CCTVOtherInstallType?: string;
    ElectricalDifferentTypeCv?: number;
    ElectricalWorkTypeCv?: number;
    ElectricalOtherDifferentType?: string;
    CCTVInstallTypeCv?: number;
    InfoNeededNote?: string;
    EstimatedStartDate?: string;
    EstimatedJobCompletionDate?: string;
    FireAlarmAdditionalDevices?: number;
    PlenumRated?: boolean;
    WorkplaceSquareFeet?: number;
    ExpirationDate?: string;
    NewConstruction?: boolean;
    ExistingBuilding?: boolean;
    FollowUpDate?: string;
    Jurisdiction?: string;
    FollowUpDescription?: string;
    InspectionStateCv?: number;

    // Display Attributes
    PermitIdDisplay?: string;
    RequestedByUserDisplay?: string;
    PermitTypeCvDisplay?: string;
    PerformingWorkCvDisplay?: string;
    AssignedToUserDisplay?: string;
    CableTypeCvDisplay?: string;
    PermitStatusWsDisplay?: string;
    JobIdDisplay?: string;
    PermitTeamCvDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;
    AttachmentIdDisplay?: string;
    PropertyOwnerStateIdDisplay?: string;
    JobSiteIdDisplay?: string;
    NoteParentIdDisplay?: string;
    PermitRequestidDisplay?: string;
    PlenumOrRiserCvDisplay?: string;
    AccessControlTypeCvDisplay?: string;
    ElectricalOutletTypeCvDisplay?: string;
    FireAlarmDemoInstallCvDisplay?: string;
    ElectricalDifferentTypeCvDisplay?: string;
    ElectricalWorkTypeCvDisplay?: string;
    CCTVInstallTypeCvDisplay?: string;
    InspectionStateCvDisplay?: string;
    // Relations
    PermitRequestidPermitRequest? : PermitRequestEntity;
    PermitTypeCvEthosCodeValue? : EthosCodeValueEntity;
    PlenumOrRiserCvEthosCodeValue? : EthosCodeValueEntity;
    ElectricalDifferentTypeCvCodeValue? : CodeValueEntity;
    ElectricalOutletTypeCvCodeValue? : CodeValueEntity;
    AccessControl? : AccessControlEntity[];
    PermitTeamCvEthosCodeValue? : EthosCodeValueEntity;
    AccessControlTypeCvCodeValue? : CodeValueEntity;
    AssignedToUserEthosUser? : EthosUserEntity;
    Inspection? : InspectionEntity[];
    FireAlarmDemoInstallCvCodeValue? : CodeValueEntity;
    CCTVInstallTypeCvCodeValue? : CodeValueEntity;
    PermitPermitType? : PermitPermitTypeEntity[];
    CreatedByEthosEthosUser? : EthosUserEntity;
    PerformingWorkCvEthosCodeValue? : EthosCodeValueEntity;
    ElectricalWorkTypeCvCodeValue? : CodeValueEntity;
    CableTypeCvEthosCodeValue? : EthosCodeValueEntity;
    PermitStatusWsEthosWorkflowStatus? : EthosWorkflowStatusEntity;
    PermitRequestPermit? : PermitRequestPermitEntity[];
    ModifiedByEthosEthosUser? : EthosUserEntity;
    RequiredCable? : RequiredCableEntity[];
    InspectionStateCvCodeValue? : CodeValueEntity;
    EthosJobSite? : EthosJobSiteEntity;
    CableTypeCvCodeValue? : CodeValueEntity;
    RoPermits? : RoPermitsEntity;
    EthosJob? : EthosJobEntity;
    DataCablePermitRequest? : PermitRequestEntity[];
    RoInspections? : RoInspectionsEntity[];
    RequestedByUserEthosUser? : EthosUserEntity;
}

export interface PermitPermitTypeEntity extends DwOrmData {
    // Attributes
    PermitPermitTypeId?: number;
    PermitId?: number;
    PermitTypeCv?: number;

    // Display Attributes
    PermitIdDisplay?: string;
    PermitTypeCvDisplay?: string;
    // Relations
    PermitTypeCvCodeValue? : CodeValueEntity;
    Permit? : PermitEntity;
    PermitTypeCvEthosCodeValue? : EthosCodeValueEntity;
}

export interface PermitRequestEntity extends DwOrmData {
    // Attributes
    PermitRequestId?: number;
    RequestedByUserId?: number;
    PermitTypeCv?: number;
    StatusCv?: number;
    DueDate?: string;
    WJID?: string;
    ScopeOfWork?: string;
    PulledOnline?: boolean;
    InspectionRequestDate?: string;
    InspectionCompleteDate?: string;
    WachterPermitNumber?: string;
    Valuation?: number;
    PermitCost?: number;
    PerformingWorkCv?: number;
    SubLicenseNumber?: string;
    PermitTeamCv?: number;
    AssignedToUserId?: number;
    NumberOfFloors?: number;
    FacilitySquareFeet?: number;
    PlenumOrRiser?: number;
    BuildingPermitNumber?: string;
    UndergroundCabling?: boolean;
    CablingInConduit?: boolean;
    GCName?: string;
    PropertyOwnerName?: string;
    Address?: string;
    City?: string;
    StateProvinceId?: number;
    Zipcode?: string;
    AttachmentId?: number;
    JobSiteId?: number;
    CableTypeCv?: number;
    ConstructionType?: string;
    JobId?: number;
    OpportunityId?: number;
    DataCableQuantity?: number;
    HasCameras?: boolean;
    CamerasQuantity?: number;
    HasSpeakers?: boolean;
    SpeakersQuantity?: number;
    HasFireAlarm?: boolean;
    NumberAditionalDevices?: number;
    NumberNaNC?: number;
    IsSwappingOutPanel?: boolean;
    HasElectrical?: boolean;
    OutletQuantity?: number;
    TotalAmps?: number;
    PanelsQuantity?: number;
    CircuitsQuantity?: number;
    HasAccessControl?: boolean;
    AccessControlCV?: number;
    AccessControlQuantity?: number;
    CardReader?: boolean;
    CardReaderQuantity?: number;
    Paging?: boolean;
    HasPanelInstalation?: boolean;
    BuglarAlarmPanelQuantity?: number;
    BuglarAlarmDeviceType?: string;
    PerformWork?: number;
    SubContractorLicenseNumber?: string;
    SpecificDescription?: string;
    NumberOfRooms?: number;
    FacilitySquareFootage?: number;
    WorkspaceSquareFootage?: number;
    PlenumRiser?: number;
    HasUndergroundCabling?: boolean;
    HasCableInConduit?: boolean;
    ValuationOverallContract?: number;
    ValuationOverallSOW?: number;
    ExpectedStartDate?: string;
    ExpectedCompletion?: string;
    PermitRequestTypeCv?: number;
    CreatedByDateTime?: string;
    CreatedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    DataCablePermitId?: number;
    SecondaryAssignedToUserId?: number;
    CriticalPower?: boolean;
    JobSiteAddress1?: string;
    JobSiteAddress2?: string;
    CountyId?: number;
    PostalCode?: string;
    PermitRequestJobType?: number;
    GCPresent?: boolean;
    HasAudioVisual?: boolean;
    HasBurglarAlarm?: boolean;
    VoiceDataCableTypeCV?: number;
    VoiceDataQuantity?: number;
    VoiceDataPlenumRated?: boolean;
    HasCCTV?: boolean;
    CCTVCableTypeCV?: number;
    CCTVQuantity?: number;
    CCTVPlenumRated?: boolean;
    HasAudio?: boolean;
    AudioCableTypeCV?: number;
    AudioQuantity?: number;
    AudioPlenumRated?: boolean;
    IsNewFireSystem?: boolean;
    HasDataVoice?: boolean;
    GCPermitNumber?: string;
    FloorCount?: number;
    DataVoiceOtherCable?: string;
    CCTVOtherCable?: string;
    AudioVisualOtherCable?: string;
    NoteParentId?: number;
    ElectricalOutletTypeCv?: number;
    ElectricalOtherOutletType?: string;
    IsLicensedTechnician?: boolean;
    TechnicianNameAndLicenseNumber?: string;
    ElectricalOtherWorkType?: string;
    ElectricalTotalVoltage?: number;
    IsTyingIntoFireAlarm?: boolean;
    FireAlarmInitiatingDevices?: number;
    FireAlarmDemoInstallCv?: number;
    DataVoiceUsingExisting?: boolean;
    DataVoiceReplacingCable?: boolean;
    DataVoiceNewCable?: boolean;
    CCTVUsingExisting?: boolean;
    CCTVReplacingCable?: boolean;
    CCTVNewCable?: boolean;
    CCTVInstallTypeCv?: number;
    CCTVOtherInstallType?: string;
    ElectricalDifferentTypeCv?: number;
    ElectricalWorkTypeCv?: number;
    AccessControlOther?: string;
    AccessControlOtherTypeCv?: number;
    ElectricalOtherDifferentType?: string;
    FireAlarmInstallRadio?: boolean;
    IsLicenceRequired?: boolean;
    HasLicenseFile?: boolean;
    WorkplaceSquareFeet?: number;
    FollowUpDate?: string;
    RushRequested?: boolean;
    RequestCompleteDate?: string;
    NewConstruction?: boolean;
    ExistingBuilding?: boolean;
    Jurisdiction?: string;
    FollowUpDescription?: string;

    // Display Attributes
    PermitRequestIdDisplay?: string;
    RequestedByUserIdDisplay?: string;
    PermitTypeCvDisplay?: string;
    StatusCvDisplay?: string;
    WJIDDisplay?: string;
    PerformingWorkCvDisplay?: string;
    PermitTeamCvDisplay?: string;
    AssignedToUserIdDisplay?: string;
    PropertyOwnerNameDisplay?: string;
    StateProvinceIdDisplay?: string;
    AttachmentIdDisplay?: string;
    JobSiteIdDisplay?: string;
    CableTypeCvDisplay?: string;
    JobIdDisplay?: string;
    OpportunityIdDisplay?: string;
    AccessControlCVDisplay?: string;
    PerformWorkDisplay?: string;
    PlenumRiserDisplay?: string;
    PermitRequestTypeCvDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;
    DataCablePermitIdDisplay?: string;
    SecondaryAssignedToUserIdDisplay?: string;
    CountyIdDisplay?: string;
    PermitRequestJobTypeDisplay?: string;
    VoiceDataCableTypeCVDisplay?: string;
    CCTVCableTypeCVDisplay?: string;
    AudioCableTypeCVDisplay?: string;
    NoteParentIdDisplay?: string;
    ElectricalOutletTypeCvDisplay?: string;
    FireAlarmDemoInstallCvDisplay?: string;
    CCTVInstallTypeCvDisplay?: string;
    ElectricalDifferentTypeCvDisplay?: string;
    ElectricalWorkTypeCvDisplay?: string;
    AccessControlOtherTypeCvDisplay?: string;
    // Relations
    PermitTypeCvEthosCodeValue? : EthosCodeValueEntity;
    WJIDEthosJob? : EthosJobEntity;
    PermitRequestTypeCvCodeValue? : CodeValueEntity;
    RequiredCable? : RequiredCableEntity[];
    CCTVInstallTypeCvCodeValue? : CodeValueEntity;
    PermitRequestPermitType? : PermitRequestPermitTypeEntity[];
    ElectricalWorkTypeCvCodeValue? : CodeValueEntity;
    PermitRequestidPermit? : PermitEntity[];
    StatusCvCodeValue? : CodeValueEntity;
    EthosJob? : EthosJobEntity;
    ElectricalOutletTypeCvCodeValue? : CodeValueEntity;
    // Duplicate property excluded
    // EthosJob : EthosJobEntity;
    // Duplicate property excluded
    // EthosJob : EthosJobEntity;
    CreatedByEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    RoPermitRequests? : RoPermitRequestsEntity;
    SecondaryAssignedToEthosUser? : EthosUserEntity;
    AssignedToEthosUser? : EthosUserEntity;
    PermitRequestPermit? : PermitRequestPermitEntity[];
    PlenumRiserEthosCodeValue? : EthosCodeValueEntity;
    DataCablePermit? : PermitEntity;
    ElectricalDifferentTypeCvCodeValue? : CodeValueEntity;
    EthosOpportunity? : EthosOpportunityEntity;
    EthosJobSite? : EthosJobSiteEntity;
    AccessControl? : AccessControlEntity[];
    CableTypeCvEthosCodeValue? : EthosCodeValueEntity;
    AccessControlOtherTypeCvCodeValue? : CodeValueEntity;
    VoiceDataCableTypeCVCodeValue? : CodeValueEntity;
    PermitTeamCvEthosCodeValue? : EthosCodeValueEntity;
    RoPermitRequestLastNote? : RoPermitRequestLastNoteEntity;
    FireAlarmDemoInstallCvCodeValue? : CodeValueEntity;
    CCTVCableTypeCVCodeValue? : CodeValueEntity;
    // Duplicate property excluded
    // EthosJob : EthosJobEntity;
    AudioCableTypeCVCodeValue? : CodeValueEntity;
    AccessControlCVCodeValue? : CodeValueEntity;
    RequestedByEthosUser? : EthosUserEntity;
}

export interface PermitRequestPermitEntity extends DwOrmData {
    // Attributes
    PermitRequestId?: number;
    PermitId?: number;
    PermitTypeCV?: number;
    PermitRequestPermitId?: number;

    // Display Attributes
    PermitRequestIdDisplay?: string;
    PermitIdDisplay?: string;
    PermitTypeCVDisplay?: string;
    // Relations
    PermitRequest? : PermitRequestEntity;
    PermitTypeCVEthosCodeValue? : EthosCodeValueEntity;
    Permit? : PermitEntity;
}

export interface PermitRequestPermitTypeEntity extends DwOrmData {
    // Attributes
    PermitRequestPermitTypeId?: number;
    PermitRequestId?: number;
    PermitTypeCv?: number;

    // Display Attributes
    PermitRequestIdDisplay?: string;
    PermitTypeCvDisplay?: string;
    // Relations
    PermitTypeCvCodeValue? : CodeValueEntity;
    PermitRequest? : PermitRequestEntity;
    PermitTypeCvEthosCodeValue? : EthosCodeValueEntity;
}

export interface PermitStatusEntity extends DwOrmData {
    // Attributes
    PermitStatusId?: number;
    PermitStatusDisplay?: string;
    PermitSsatusMeaning?: string;
    PermitStatusOrder?: number;
    IsActive?: boolean;
    PermitStatusShortName?: string;

    // Relations
}

export interface RequiredCableEntity extends DwOrmData {
    // Attributes
    RequiredCableId?: number;
    CableTypeCv?: number;
    Quantity?: number;
    Description?: string;
    PermitRequestId?: number;
    PermitId?: number;
    CreatedByDateTime?: string;
    CreatedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    PermitTypeCv?: number;

    // Display Attributes
    CableTypeCvDisplay?: string;
    PermitRequestIdDisplay?: string;
    PermitIdDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;
    PermitTypeCvDisplay?: string;
    // Relations
    PermitTypeCvEthosCodeValue? : EthosCodeValueEntity;
    Permit? : PermitEntity;
    CreatedByEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    PermitRequest? : PermitRequestEntity;
}

export interface RoEthosUserEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    UserName?: string;
    FirstName?: string;
    LastName?: string;
    MiddleName?: string;
    PreferredName?: string;
    Suffix?: string;
    OfficePhone?: string;
    MobilePhone?: string;
    WachterJobTitleId?: number;
    WachterJobTitle?: string;
    UserTypeCv?: number;
    UserTypeDisplay?: string;
    StaffingAgencyId?: number;
    ResourceGroupCv?: number;
    ResourceGroup?: string;
    EmployeeGroupId?: number;
    EmployeeGroupCode?: string;
    EmployeeGroupDescription?: string;
    empHireDate?: string;
    AddressLongitude?: number;
    AddressLatitude?: number;
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    BirthMonth?: number;
    BirthDate?: number;
    Email?: string;
    SupervisorUserId?: number;
    UserStatusWs?: number;
    UserStatusMeaning?: string;
    IsTerminated?: boolean;
    PictureAttachmentFileExtension?: string;
    PictureAttachmentDisplay?: string;
    PictureAttachmentField?: number;
    AdjustedStartDate?: string;
    OfficeId?: number;
    OfficeName?: string;
    StreetAddress1?: string;
    StreetAddress2?: string;
    City?: string;
    StateProvinceShortName?: string;
    PostalCode?: string;
    HasVehicle?: boolean;
    ShowUserOnMap?: boolean;
    RowInsertDateTime?: string;
    TeamName?: string;
    TeamShortName?: string;
    TeamNickName?: string;
    DepartmentName?: string;
    DepartmentShortName?: string;
    WachterDivisionId?: number;
    DivisionName?: string;
    DivisionShortName?: string;
    NameLastFirst?: string;
    NameLastPrefered?: string;
    NameLastFirstPrefered?: string;
    NameFirstLast?: string;
    NamePreferedLast?: string;
    NameFirstPreferedLast?: string;
    NameFirstMiddleLast?: string;
    NamePreferedMidInitialLast?: string;
    NameLastFirstPreferedStatus?: string;
    EmployeeType?: string;
    StateProvinceId?: number;
    PictureAttachmentFileKey?: string;
    NameLastFirstPreferedType?: string;
    IsActive?: number;
    SpecialInstructions?: string;
    BirthMonthDate?: string;
    TerritoryId?: number;
    TerritoryName?: string;
    Company?: string;
    LicenseCount?: number;
    AXId?: string;
    YrsService?: number;
    StaffingAgencyName?: string;

    // Display Attributes
    UserIdDisplay?: string;
    UserTypeCvDisplay?: string;
    WachterTeamIdDisplay?: string;
    WachterDepartmentIdDisplay?: string;
    SupervisorUserIdDisplay?: string;
    // Relations
    UserStatusWsEthosWorkflowStatus? : EthosWorkflowStatusEntity;
    EthosUser? : EthosUserEntity;
    SupervisorRoEthosUser? : RoEthosUserEntity;
    // Duplicate property excluded
    // SupervisorRoEthosUser : RoEthosUserEntity[];
}

export interface RoEthosUserOriginalEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    AXId?: string;
    UserName?: string;
    FirstName?: string;
    LastName?: string;
    MiddleName?: string;
    PreferredName?: string;
    Suffix?: string;
    OfficePhone?: string;
    MobilePhone?: string;
    WachterJobTitleId?: number;
    WachterJobTitle?: string;
    UserTypeCv?: number;
    UserTypeDisplay?: string;
    EmployeeType?: string;
    StaffingAgencyId?: number;
    ResourceGroupCv?: number;
    ResourceGroup?: string;
    EmployeeGroupId?: number;
    EmployeeGroupCode?: string;
    EmployeeGroupDescription?: string;
    empHireDate?: string;
    AddressLongitude?: number;
    AddressLatitude?: number;
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    BirthMonth?: number;
    BirthDate?: number;
    BirthMonthDate?: string;
    Email?: string;
    SupervisorUserId?: number;
    UserStatusWs?: number;
    UserStatusMeaning?: string;
    IsActive?: number;
    IsTerminated?: boolean;
    PictureAttachmentFileExtension?: string;
    PictureAttachmentDisplay?: string;
    PictureAttachmentFileKey?: string;
    PictureAttachmentField?: number;
    AdjustedStartDate?: string;
    OfficeId?: number;
    OfficeName?: string;
    StreetAddress1?: string;
    StreetAddress2?: string;
    City?: string;
    StateProvinceId?: number;
    StateProvinceShortName?: string;
    TerritoryId?: number;
    TerritoryName?: string;
    PostalCode?: string;
    HasVehicle?: boolean;
    ShowUserOnMap?: boolean;
    SpecialInstructions?: string;
    RowInsertDateTime?: string;
    TeamName?: string;
    TeamShortName?: string;
    TeamNickName?: string;
    DepartmentName?: string;
    DepartmentShortName?: string;
    WachterDivisionId?: number;
    DivisionName?: string;
    DivisionShortName?: string;
    Company?: string;
    LicenseCount?: number;
    NameLastFirst?: string;
    NameLastPrefered?: string;
    NameLastFirstPrefered?: string;
    NameFirstLast?: string;
    NamePreferedLast?: string;
    NameFirstPreferedLast?: string;
    NameFirstMiddleLast?: string;
    NamePreferedMidInitialLast?: string;
    NameLastFirstPreferedStatus?: string;
    NameLastFirstPreferedType?: string;

    // Relations
}

export interface RoInspectionsEntity extends DwOrmData {
    // Attributes
    TechMobile?: string;
    TechOffice?: string;
    TechEmail?: string;
    InspectionId?: number;
    InspectionType?: string;
    TechnicianOnSite?: boolean;
    TechnicianUserId?: number;
    AvailableDates?: string;
    PreferredTimeOfDayCv?: number;
    AdditionalNotes?: string;
    PermitId?: number;
    CreatedByDateTime?: string;
    CreatedByEthos_UserId?: number;
    InspectionNotes?: string;
    ScheduledDateTime?: string;
    ScheduledNotes?: string;
    ResultCv?: number;
    ResultDateTime?: string;
    ResultNotes?: string;
    AdditionalInspectionNeeded?: boolean;
    PreferredTimeOfDay?: string;
    Result?: string;
    TechFirstName?: string;
    TechLastName?: string;

    // Display Attributes
    TechnicianUserIdDisplay?: string;
    PreferredTimeOfDayCvDisplay?: string;
    PermitIdDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;
    ResultCvDisplay?: string;
    // Relations
    Permit? : PermitEntity;
}

export interface RoPermitRequestLastNoteEntity extends DwOrmData {
    // Attributes
    PermitRequestId?: number;
    Note?: string;
    NoteId?: number;

    // Relations
    PermitRequest? : PermitRequestEntity[];
}

export interface RoPermitRequestsEntity extends DwOrmData {
    // Attributes
    PermitRequestId?: number;
    RequestedByUserId?: number;
    JobId?: number;
    OpportunityId?: number;
    JobNumberId?: number;
    StreetAddress1?: string;
    StreetAddress2?: string;
    City?: string;
    CountyId?: number;
    StateProvinceId?: number;
    CountyName?: string;
    StateProvinceName?: string;
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    WachterDivisionId?: number;

    // Display Attributes
    RequestedByUserIdDisplay?: string;
    JobNumberIdDisplay?: string;
    StateProvinceIdDisplay?: string;
    // Relations
    PermitRequest? : PermitRequestEntity[];
}

export interface RoPermitsEntity extends DwOrmData {
    // Attributes
    PermitId?: number;
    RequestedByUser?: number;
    PermitStatusWs?: number;
    DueDate?: string;
    JobId?: number;
    CanBePulledOnline?: boolean;
    InspectionRequestDate?: string;
    InspectionCompleteDate?: string;
    WachterPermitNumber?: string;
    PermitCost?: number;
    PerformingWorkCv?: number;
    SubcontractorLicense?: string;
    PermitTeamCv?: number;
    AssignedToUser?: number;
    FloorCount?: number;
    FacilitySquareFeet?: number;
    CableTypeCv?: number;
    BuildingPermitNumber?: string;
    UndergroundCablingPresent?: boolean;
    CablingInConduitPresent?: boolean;
    GCPresent?: boolean;
    GCName?: string;
    PropertyOwnerName?: string;
    PropertyOwnerCity?: string;
    PropertyOwnerStateId?: number;
    PropertyOwnerPostalCode?: string;
    CreatedByDateTime?: string;
    CreatedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    AttachmentId?: number;
    JobSiteId?: number;
    ScopeOfWork?: string;
    SharepointId?: number;
    PropertyOwnerAddress?: string;
    PermitTypeCv?: number;
    NoteParentId?: number;
    JobNumberId?: number;
    OpportunityId?: number;
    OverallContractValuation?: number;
    StreetAddress1?: string;
    StreetAddress2?: string;
    City?: string;
    StateProvinceId?: number;
    SiteTypeCv?: number;
    JobNumberName?: string;
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    WachterDivisionId?: number;
    CountyId?: number;
    CountyName?: string;
    InspectionStateCv?: number;

    // Display Attributes
    RequestedByUserDisplay?: string;
    PermitStatusWsDisplay?: string;
    JobIdDisplay?: string;
    PerformingWorkCvDisplay?: string;
    PermitTeamCvDisplay?: string;
    AssignedToUserDisplay?: string;
    CableTypeCvDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;
    PermitTypeCvDisplay?: string;
    JobNumberIdDisplay?: string;
    OpportunityIdDisplay?: string;
    StateProvinceIdDisplay?: string;
    SiteTypeCvDisplay?: string;
    // Relations
    Permit? : PermitEntity[];
}

    // Lookup Value Enums  {
export enum CodeValuePermitType {
        AccessControl = 103818,
        AudioVisual = 103819,
        BurglarAlarm = 103820,
        DataVoice = 103821,
        Electrical = 103822,
        FireAlarm = 103823,
        CCTV = 103838,
    }

// Excluding lookup PermitPermitType All Items because it contains 334 items which exceeds the max item setting of 100.  Override in cli config for code gen using ExcludeLookupsMaxCount
// Excluding lookup PermitRequestPermitType All Items because it contains 102 items which exceeds the max item setting of 100.  Override in cli config for code gen using ExcludeLookupsMaxCount
export enum CodeValuePayJobChangeType {
        SalaryChange = 161,
        WageChange = 163,
        WageToSalary = 164,
        SalaryToWage = 165,
    }

export enum CodeValueTermResignType {
        CareerChange = 168,
        CorporateRestructuring = 169,
        ExcessiveTravel = 170,
        LackOfWork = 171,
        MaternityLeave = 172,
        Personal = 173,
        ReductionInStaff = 174,
        Relocation = 175,
        Retirement = 176,
        School = 177,
        TookHigherPayingJob = 178,
        WorkSchedule = 179,
        Absenteeism = 180,
        GrossMisconduct = 181,
        Insubordination = 182,
        NeverStarted = 183,
        NoCallNoShow = 184,
        NoContact = 185,
        PolicyViolation = 186,
        PoorPerformance = 187,
        QuitWithoutNotice = 188,
        SafetyViolation = 189,
        SubstanceAbuse = 190,
        WalkedOffJob = 191,
        PassedAway = 192,
    }

export enum CodeValueMemoOfRecordEmployeeType {
        WachterAndStaffing = 78,
        Subcontractor = 81,
    }

export enum CodeValueMemoOfRecordIssueType {
        Safety = 22,
        Professionalism = 23,
        Theft = 24,
        Harassment = 25,
        Kudos = 26,
        WAM = 27,
        DOT = 28,
        Mentionable = 29,
        AccountingHR = 80,
    }

    // Error loading lookup values for Code Value - MOR SubType - By Issue Type(1513
export enum CodeValueMemoOfRecordIssueSubTypeAll {
        PPE = 30,
        HLI = 31,
        JHA = 32,
        VehicleAccident = 33,
        JobSiteAccident = 34,
        DriverAlert = 35,
        Insubordination = 36,
        Appearance = 37,
        MissedETA = 38,
        Quality = 39,
        Communication = 40,
        LossDamageOfCompanyProperty = 41,
        PolicyProcessProcedure = 42,
        WorkEthic = 43,
        Other = 44,
        OfficeHours = 45,
        Sexual = 46,
        Physical = 47,
        Verbal = 48,
        // Duplicate property Name found
        Other_49 = 49,
        Kudos = 50,
        Num11HoursTravel = 51,
        Num14HoursWorked = 52,
        Num70HoursWorked = 53,
        RequiredBreak = 54,
        FailedCheckpoint = 55,
        FailureToReportCheckpoint = 56,
        FailureToSubmitLogs = 57,
        ParkingViolation = 58,
        Mileage = 59,
        Labor = 60,
        PerDiem = 61,
        MisuseOfCompanyPhoneComputer = 62,
        NoCallNoShow = 63,
        ScopeDeviation = 64,
        RedLightViolation = 65,
        MovingViolation = 66,
        Num16HoursWorked = 67,
        SkillSetKnowledge = 68,
        CustomerApplication = 86,
        ContractReviewStorage = 87,
        WAM = 120,
        LessonsLearned = 121,
        RiskRegister = 122,
        CustomerPropery = 123,
        WachterProperty = 124,
    }

export enum CodeValueAccidentType {
        HitAndRun = 203,
        Moving = 204,
        NotAtFault = 205,
        ParkingLot = 206,
        Wildlife = 207,
        BreakIn = 335,
        Incident = 341,
        NearMiss = 342,
    }

export enum CodeValueTechType {
        Service = 141,
        Project = 142,
        Installation = 143,
        Alarm = 144,
        PhysicalSecurity = 145,
        CCTV = 146,
        AccessControl = 147,
        LBUTech = 148,
        Helper = 242,
    }

export enum CodeValueBusinessPlanReviewAccidentType {
        Vehicle = 138,
        Onsite = 140,
    }

export enum CodeValueTravelType {
        CustomerVisit = 251,
        JobSiteCheckup = 252,
        SiteWalkSurvey = 253,
        BillableLabor = 254,
        Other = 255,
    }

export enum CodeValueWorksiteType {
        OSHA = 292,
        MSHA = 293,
    }

export enum CodeValueAccidentTypeWorkplace {
        Accident = 294,
        NearMiss = 295,
        PropertyDamage = 296,
        IncidentOnly = 297,
    }

export enum CodeValueInjuryType {
        Abraision = 322,
        Burn = 323,
        Concussion = 324,
        Contusion = 325,
        ForeignBody = 326,
        Fracture = 327,
        Inhalation = 328,
        Laceration = 329,
        MuscleStrain = 330,
        Other = 331,
        Puncture = 332,
        Shock = 333,
        Sprain = 334,
    }

export enum EthosUserTypeCodeValue {
        Wachter = 497,
        Customer = 540,
        Subcontractor = 541,
        ContractStaffing = 2626,
        ThirdPartyCustomer = 102653,
    }

export enum CodeValueWorkerType {
        Wachter = 103834,
        Subcontractor = 103835,
    }

export enum CodeValuePermitRequestType {
        PermitResearch = 349,
        PermitApplication = 350,
        PermitApplicationAndResearch = 351,
    }

export enum CodeValuePermitRequestCableType {
        Cat5e = 352,
        Cat6 = 353,
        Fiber = 354,
        Other = 367,
        Cat6a = 389,
    }

export enum PermitRequestJobTypeLookup {
        WJID = 365,
        Opportunity = 366,
        JobNumber = 394,
    }

export enum NoteTypeAllItems {
        Default = 1,
        Permits = 2,
        PermitUpdateRequest = 3,
        PermitInfoFromPM = 4,
        StarRatings = 5,
        PermitInspectionNeeded = 6,
        PermitRequest = 7,
    }

export enum CodeValuePermitRequestElectricalOutletType {
        Duplex = 368,
        Quad = 369,
        Other = 370,
    }

// Excluding lookup Code Value - Different Type of Electrical because it contains 375 items which exceeds the max item setting of 100.  Override in cli config for code gen using ExcludeLookupsMaxCount
export enum CodeValueTypesOfElectrical {
        SinglePullSwitch = 371,
        PowerPull = 372,
        OtherOutletType = 373,
    }

export enum CodeValueElectricalNewWorkType {
        NewAddition = 377,
        NewAlteration = 378,
        OtherWorkType = 379,
    }

export enum CodeValueCCTVTypesOfInstall {
        CamerasCable = 385,
        Cameras = 386,
        Cable = 387,
        Other = 388,
    }

export enum PermitRequestJobTypeLookupNoJobNumber {
        WJID = 365,
        Opportunity = 366,
    }

export enum InspectionAllItems {
        Test = 35,
        Type1A = 44,
        Type2 = 45,
        Type3 = 46,
        RoughInspection = 47,
        Final = 48,
        TEST = 49,
        Test2 = 50,
        TESTRequest = 51,
        Sdf = 52,
    }

export enum CodeValueInspectionTimeOfDay {
        Mornings = 397,
        Afternoons = 398,
        NoPreference = 399,
    }

export enum CodeValueInspectionState {
        AllowInitialInspection = 400,
        AdditionalInspectionsNeeded = 401,
        AllInspectionsComplete = 402,
    }

export enum RoInspectionsAllItems {
        Num8104472475 = 35,
        Num4798796140 = 44,
        Num7322680011 = 45,
        None = 46,
        Num4798794038 = 47,
        // Duplicate property Name found
        Num4798794038_48 = 48,
        Num4798795562 = 49,
        // Duplicate property Name found
        None_50 = 50,
        Num4792254152 = 51,
        // Duplicate property Name found
        Num8104472475_52 = 52,
    }

export enum CodeValueInspectionResults {
        Pass = 403,
        Fail = 404,
    }

// Excluding lookup Trust CodeValue All Items because it contains 375 items which exceeds the max item setting of 100.  Override in cli config for code gen using ExcludeLookupsMaxCount
export enum CodeValueEquipmentDelivery {
        WeNeedDeliveredToSite = 130,
        WeNeedAQuoteFor = 132,
        WeWillPickUpAtBranch = 241,
    }

export enum CodeValuePayJobChangeStatus {
        Pending = 153,
        PendingManagerApproval = 154,
        PendingDepartmentHeadApproval = 155,
        PendingDivisionHeadApproval = 156,
        PendingExecutiveApproval = 157,
        Rejected = 158,
        Approved = 159,
    }

export enum CodeValuePayJobChangeDepartmentRole {
        DepartmentHead = 166,
        DivisionHead = 167,
    }

export enum CodeValueMemoOfRecordConclusion {
        Discussed = 16,
        VerbalWritten = 17,
        FinalWritten = 18,
        Termination = 19,
        DocumentationOnly = 20,
        PerformanceImprovementPlan = 21,
        Unsubstantiated = 196,
    }

export enum CodeValueMORStatus {
        Open = 194,
        Closed = 195,
    }

export enum CodeValueEmployeeTrainingNeeded {
        JobSetUp = 88,
        OCIPCCIP = 89,
        PrevailingWage = 90,
        BillingRequirements = 91,
        ChangeOrderManagement = 92,
        BISSubmission = 93,
        LaborApproval = 94,
        VendorPOs = 95,
        InvoiceApprovals = 96,
        CreditCardsExpenses = 97,
        Collections = 98,
        ForecastingAndWIP = 99,
        PayrollAndBurden = 100,
        LienWaivers = 101,
        SexualHarassmentAndHarassmentTraining = 102,
        DisciplinaryActionsHR208 = 103,
        PrevailingWageReporting = 104,
        // Duplicate property Name found
        OCIPCCIP_105 = 105,
        FMLAAndTheirResponsibilities = 106,
        BusinessProtectionAgreements = 107,
        EmployeeEvaluations = 116,
        EmployeeInterviews = 117,
        Safety = 118,
        OfferLetterAndExpectations = 119,
    }

export enum CodeValueEmployeeTrainingNeededConclusion {
        TrainingDelivered = 197,
        FurtherInformationNeeded = 198,
        MORNeeded = 199,
        NoIssueIdentified = 200,
    }

export enum CodeValueEmployeeTrainingNeededStatus {
        Open = 201,
        Closed = 202,
    }

export enum CodeValueAtFault {
        Yes = 208,
        No = 209,
        WordVsWord = 210,
    }

export enum CodeValueVechicleRepaired {
        Pending = 211,
        Rental = 212,
        TotalLoss = 213,
        WillNotRepair = 214,
        Yes = 215,
    }

export enum CodeValueClaimStatus {
        Open = 216,
        Closed = 217,
        Pending = 218,
    }

export enum CodeValueInsuranceCompany {
        Allied = 219,
        Allstate = 220,
        AmericanFamily = 221,
        DirectAuto = 222,
        Encompass = 223,
        Esurance = 224,
        Farmers = 225,
        Geico = 226,
        LibertyMutual = 227,
        Metlife = 228,
        Nationwide = 229,
        PlymouthRock = 230,
        Progressive = 231,
        SafeAuto = 232,
        Safeco = 233,
        StateFarm = 234,
        TheHartford = 235,
        Travelers = 236,
        United = 237,
        USAA = 238,
        Zurich = 239,
        Other = 240,
        ArchInsurance = 405,
    }

export enum CodeValueTravelMode {
        Flight = 243,
        CarRental = 244,
        CompanyLoaner = 245,
        Other = 246,
    }

export enum CodeValueAirportPlan {
        LongTermParking = 256,
        DroppedOff = 257,
        UberLyftCab = 258,
        Other = 259,
    }

export enum CodeValueTransportationPlan {
        RentCar = 260,
        RentPassengerVan = 261,
        UberLyftCab = 262,
        Other = 263,
        RentTruckSUV = 266,
    }

export enum CodeValueLodgingPlan {
        BookedAheadByAdmin = 247,
        SpotAndStayWithCorpCC = 248,
        ClaimPerDiemHourlyStaffOnly = 249,
        Other = 250,
    }

export enum CodeValueTravelRequestStatus {
        Open = 264,
        Closed = 265,
    }

export enum CodeValueFiveStarRatingValue {
        Num1 = 267,
        Num2 = 268,
        Num3 = 269,
        Num4 = 270,
    }

// Excluding lookup Ethos_CodeValue All Items because it contains 1420 items which exceeds the max item setting of 100.  Override in cli config for code gen using ExcludeLookupsMaxCount
export enum CodeValueEmsWorkStatus {
        Unassigned = 272,
        Temp = 273,
        Active = 274,
        AutoDispatch = 275,
        OnLend = 276,
        Probation = 277,
        MedicalLeave = 278,
        SickLeave = 279,
        Disability = 280,
        LimitedWorkRelease = 281,
        Suspended = 282,
        DoNotContactDNC = 283,
        PersonalTimeOffPTO = 284,
        Unavailable = 285,
        Remote = 286,
        Terminated = 287,
        Resigned = 289,
        Deceased = 290,
        Retired = 291,
    }

export enum CodeValueBodyPart {
        Head = 300,
        Eye = 301,
        Nose = 302,
        Mouth = 303,
        Neck = 304,
        BackUpper = 305,
        BackLower = 306,
        Chest = 307,
        Shoulder = 308,
        Arm = 309,
        Elbow = 310,
        Wrist = 311,
        Hand = 312,
        Finger = 313,
        Groin = 314,
        Hip = 315,
        Thigh = 316,
        Knee = 317,
        ShinCalf = 318,
        Ankle = 319,
        Foot = 320,
        Toe = 321,
    }

export enum CodeValueBodySide {
        Left = 298,
        Right = 299,
    }

export enum CodeValuePlenumOrRiser {
        NA = 103814,
        Plenum = 103815,
        Riser = 103816,
        Outdoor = 103817,
    }

export enum CodeValuePermitTeam {
        NA = 103826,
        NES = 103827,
        NSPLBU = 103828,
        OperationsSupport = 103829,
        Rollout = 103830,
        WEC = 103831,
        CRITICALPOWER = 103839,
    }

// Excluding lookup Ethos_CodeValueCustom All Items because it contains 10000 items which exceeds the max item setting of 100.  Override in cli config for code gen using ExcludeLookupsMaxCount
export enum EthosWachterDepartmentAllItems {
        WCSolutionDesignTeam = 3,
        WECElectricalManagement = 26,
        WECProjectsCommercial = 27,
        WECIndustrialPower = 28,
        WECService = 29,
        WECStJoeMO = 30,
        WECLowellARElectric = 31,
        WCExecutives = 32,
        NWRollout = 39,
        NWNationwideServiceProjects = 40,
        STFContractStaffing = 41,
        WCSales = 42,
        STPPhysicalSecurity = 44,
        INTLCanada = 45,
        INTLLeedsUK = 46,
        WCInformationTechnology = 47,
        INTLPuertoRico = 64,
        WCAccounting = 65,
        WCHumanResources = 66,
        WCOperations = 71,
        STPEmergingTechnologiesOLD = 74,
        STPSustainableEnergyOLD = 75,
        WCFacilities = 76,
        WECControls = 79,
        WTSNetworkEngineering = 81,
        WTSPhysicalSecurity = 83,
        INTLCostaRica = 89,
        UKIreland = 91,
        UKLeedsUK = 92,
        LBUAtlantaGA = 93,
        LBUCharlotteNC = 94,
        LBUCincinnatiOH = 95,
        LBUColumbusOH = 96,
        LBUDallasTX = 97,
        LBUIrvineCA = 98,
        LBULenexaKS = 99,
        LBULowellAR = 100,
        LBUNashvilleTN = 101,
        LBUOrlandoFL = 102,
        LBUPhiladelphiaPA = 103,
        NWElectricalService = 104,
        LBUTulsaOK = 105,
        STPProfessionalServices = 106,
        WECDecaturIL = 107,
        WCITServices = 108,
        WECEngineering = 109,
        WECHoustonTX = 110,
        WSCWachterStaffingCorporate = 111,
        WECDallasTX = 112,
        WECColorado = 113,
        STFLBUStaffingCincinnatiLBU = 114,
        STFLBUStaffingNashvilleLBU = 115,
        WECIndustrialTechnology = 116,
        WECIndustrialNationwideProjects = 117,
        LBUDenverCO = 118,
        STFLBUStaffingAtlantaLBU = 119,
        STFLBUStaffingCharlotteLBU = 120,
        STFLBUStaffingDallasLBU = 121,
        STFLBUStaffingIrvineLBU = 122,
        STFLBUStaffingLowellLBU = 123,
        STFLBUStaffingPhiladelphiaLBU = 124,
        STFLBUStaffingSeattleLBU = 125,
        STFNWStaffingNSP = 126,
        STFNWStaffingRollout = 127,
        STFWECStaffingIndustrialPower = 128,
        STFWECStaffingIndustrialNationwideProjects = 129,
        STFWECStaffingIndustrialTech = 130,
        STFWECStaffingElectricService = 131,
        WTSIOT = 132,
        WECElectricalService = 133,
        LBUSeattleWA = 134,
        STFWCStaffingIT = 135,
        STFWCStaffingOperations = 136,
        STFWCStaffingHR = 137,
        WCRD = 138,
        LBUPhoenixAZ = 139,
        LBUSanJoseCA = 140,
        STFLBUStaffingSanJoseLBU = 141,
        STFWTSStaffingIOT = 142,
        STFWTSStaffingPhysicalSecurity = 143,
        STFWTSStaffingNetworkEngineering = 144,
        WTSWTSWAVE = 145,
        LBULBUSupport = 146,
        STFLBUStaffingLBUSupport = 147,
        STFWTSStaffingWAVE = 148,
        STFWCStaffingAccounting = 149,
    }

export enum WorkflowStatusPermitStatusDONOTUSE {
        NANoStatusAssigned = 694,
        INQInquiryOfPermitNecessityRequested = 695,
        NPRInquiryDeterminedNoPermitNeeded = 696,
        INFAdditionalInfoNeededFromPM = 697,
        PRQApplicationProcessRequestedToBegin = 698,
        AIPMunicipalityRequiresApplicationInPerson = 699,
        PAPPermitSuccessfullyAppliedFor = 700,
        PUMunicipalityRequiresPickUpInPerson = 701,
        POJMunicipalityRequiresPermitPostedOnSite = 702,
        RCVPermitReceived = 703,
        IRInspectionRequested = 704,
        ICInspectionComplete = 705,
        INInspectionNeeded = 707,
        CSNCorporateSupportNeeded = 710,
    }

export enum PermitStatusAllItems {
        NANoStatusAssigned = 694,
        INQInquiryOfPermitNecessityRequested = 695,
        NPRInquiryDeterminedNoPermitNeeded = 696,
        INFAdditionalInfoNeededFromPM = 697,
        PRQApplicationProcessRequestedToBegin = 698,
        AIPMunicipalityRequiresApplicationInPerson = 699,
        PAPPermitSuccessfullyAppliedFor = 700,
        PUMunicipalityRequiresPickUpInPerson = 701,
        POJMunicipalityRequiresPermitPostedOnSite = 702,
        RCVPermitReceived = 703,
        IRInspectionRequested = 704,
        ICInspectionComplete = 705,
        INInspectionNeeded = 707,
        CSNCorporateSupportNeeded = 710,
        CNLCanceled = 711,
        DWPWorkDoneWithoutPermit = 712,
        ISInspectionScheduled = 713,
    }




